(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Dinamic"] = factory(require("react"), require("react-dom"));
	else
		root["Dinamic"] = factory(root["React"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "env", function() { return env; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numTrunc", function() { return numTrunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepGet", function() { return deepGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "log", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return includes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trimAllBlankString", function() { return trimAllBlankString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compactArray", function() { return compactArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return isEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapValue", function() { return mapValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniqueId", function() { return getUniqueId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matchRegexp", function() { return matchRegexp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlainObject", function() { return isPlainObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareComplierVersion", function() { return compareComplierVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addScript", function() { return addScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendLog", function() { return sendLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendRateLog", function() { return sendRateLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNumberLike", function() { return isNumberLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toNumber", function() { return toNumber; });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _tracker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var CACHED_CONFIG = Object(_cache__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])('global-config');

// 匹配所有数组下标
var REG_PROCESS_EXP = /\[(\d+)\]/g;

// 匹配属性 首字符是否是特殊字符
var REG_SP_FIRST_CHAR_EXP = /^[_$]/;

var ERROR_CACHEMAP = {};

var ERROR_ONCE_WHITELIST = [_constant__WEBPACK_IMPORTED_MODULE_3__[/* ERROR_VIEW_404 */ "l"], _constant__WEBPACK_IMPORTED_MODULE_3__[/* ERROR_PARSER_404 */ "c"]];

var env = {
  isIOS: /iPhone|iPad/.test(window.navigator.userAgent),
  devicePixelRatio: window.devicePixelRatio || 1,
  deviceWidth: Math.min(768, window.innerWidth, window.screen.width)
};

/* ------------------------------------------------------------ */

var noop = function noop() {};

// 4舍6入算法。。
var numTrunc = function numTrunc(num) {
  num = parseFloat(num);

  if (isNaN(num)) {
    return NaN;
  }

  var _$split = ('' + (num + 0.4)).split('.'),
      _$split2 = _slicedToArray(_$split, 1),
      intPart = _$split2[0];

  return isNaN(intPart) ? NaN : intPart;
};

var deepGet = function deepGet(obj, expression) {
  if (!expression) {
    return null;
  }

  return [obj].concat(_toConsumableArray(expression.replace(REG_PROCESS_EXP, function (m, p1) {
    return '.' + p1;
  }).split('.'))).reduce(function (subObj, key) {
    // 对齐 Native，不能对字符串取下标
    if (typeof subObj === 'string') {
      return null;
    }
    return subObj && subObj[key];
  });
};

var log = {
  warn: function warn() {
    var _console;

    for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
      msg[_key] = arguments[_key];
    }

    return (_console = console).warn.apply(_console, ['[DinamicX warn]: '].concat(msg));
  },
  error: function error(_error, options) {
    var shouldThrow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    /**
     * options
     * 
     * update 或重新解析模版时还会触发 parser 404, view 404，不要重复上报错误了
     * 
     * {
     *   type: ERROR_PARSER_404,
     *   templateName: options._tplName,
     *   parser: name
     * } 
     */
    if (options && ~ERROR_ONCE_WHITELIST.indexOf(options.type)) {
      var errorKey = options.parser || options.viewName;
      if (ERROR_CACHEMAP[errorKey]) {
        // 只上报一次
        return;
      } else {
        ERROR_CACHEMAP[errorKey] = true;
      }
    }

    console.error('[DinamicX error]: ', _error, options || '');
    _tracker__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].report(_error, options);

    // catchSDKJSError 默认为 false，同时抛错到 window.onerror 触发 jserror 上报
    // 如果想关闭 jserror 需要业务主动配置此开关
    if (!Object(_config__WEBPACK_IMPORTED_MODULE_0__[/* getGlobalConfig */ "a"])('catchSDKJSError')) {
      var errMsg = _error && _error.message || _error;
      if (options) {
        errMsg = errMsg + ' ' + JSON.stringify(options);
      }

      if (typeof ErrorEvent !== 'undefined') {
        var dxErrorEvent = new ErrorEvent('error', {
          error: new Error(errMsg),
          message: errMsg
        });
        window.dispatchEvent(dxErrorEvent);
      }
    }

    if (shouldThrow) {
      throw _error;
    }
  }
};


var includes = function includes(s1, s2) {
  return s1.indexOf(s2) !== -1;
};

var trimAllBlankString = function trimAllBlankString(str) {
  return str.replace(/\s/g, '');
};
var compactArray = function compactArray(arr) {
  var result = [];
  arr.forEach(function (item) {
    return item && result.push(item);
  });
  return result;
};

var isEmpty = function isEmpty(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
    if (Array.isArray(obj) && obj.length === 0) {
      return true;
    } else if (isPlainObject(obj) && Object.keys(obj).length === 0) {
      return true;
    }

    return false;
  }

  return !obj;
};

var isEqual = function isEqual(v1, v2) {
  if (v1 == v2) {
    return true;
  }

  if (v1 && v2 && (typeof v1 === 'undefined' ? 'undefined' : _typeof(v1)) === (typeof v2 === 'undefined' ? 'undefined' : _typeof(v2)) && (typeof v1 === 'undefined' ? 'undefined' : _typeof(v1)) === 'object') {
    var v1Keys = Object.keys(v1);
    var v2Keys = Object.keys(v2);
    var v1Len = v1Keys.length;
    var v2Len = v2Keys.length;

    if (v1Len !== v2Len) {
      return false;
    }

    for (var i = 0; i < v1Len; i++) {
      var key = v1Keys[i];

      if (REG_SP_FIRST_CHAR_EXP.test(key)) {
        continue;
      }

      if (!isEqual(v1[key], v2[key])) {
        return false;
      }
    }

    return true;
  }

  return false;
};

var mapValue = function mapValue(obj, cb) {
  var result = {};

  for (var key in obj) {
    result[key] = cb(obj[key], key, obj);
  }

  return result;
};

var getUniqueId = function () {
  var CACHED_ID = Object(_cache__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])('id');

  return function (prefix) {
    var id = ~~CACHED_ID.get(prefix);

    CACHED_ID.set(prefix, ++id);

    return prefix + '_' + id;
  };
}();

var matchRegexp = function matchRegexp(str, reg) {
  if (str) {
    if (reg.global) {
      var result = [];
      var match = reg.exec(str);
      while (match !== null) {
        result.push(match && match.slice(1));
        match = reg.exec(str);
      }
      return result;
    } else {
      var _match = reg.exec(str);
      return _match ? _match.slice(1) : [];
    }
  }
};

// 判断是否为对象类型
var isPlainObject = function isPlainObject(val) {
  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && val.constructor === Object) {
    return true;
  }

  return false;
};

var isString = function isString(str) {
  return typeof str === 'string';
};

/* ------------------------------------------------------------ */

var compareComplierVersion = function compareComplierVersion(v1, v2) {
  var result = 0;
  for (var index in v1.split('.')) {
    var subV1 = v1[index];
    var subV2 = v2[index];

    if (subV1 === subV2) {
      continue;
    } else if (subV1 < subV2) {
      result = -1;
      break;
    }

    result = 1;
    break;
  }

  return result;
};

var addScript = function addScript(url) {
  if (!url) {
    return;
  }
  var layoutScript = document.createElement('script');
  layoutScript.src = url;
  layoutScript.charset = 'UTF-8';

  return new Promise(function (resolve, reject) {
    layoutScript.onload = function () {
      resolve();
      try {
        document.body.removeChild(layoutScript);
      } catch (e) {
        noop();
      }
    };

    layoutScript.onerror = function (err) {
      reject('Get script fail');
      try {
        document.body.removeChild(layoutScript);
      } catch (e) {
        noop();
      }
    };

    document.body.appendChild(layoutScript);
  });
};

/**
 * 发送普通埋点
 */
var sendLog = _tracker__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].log;

/**
 * 发送百分比埋点
 * @param {string} type - 标识
 * @param {boolean} success - 是否成功
 * @param {Object.<string, string>|string} msg - 消息内容
 * @param {Object} [options] - 额外配置
 */
var sendRateLog = function sendRateLog(type) {
  var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var msg = arguments[2];
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  _tracker__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].log(type, msg, _extends({
    success: success,
    type: 'api'
  }, options));
};

/**
 *  是否可以转化为数字
 * @param {any} number - 传入的参数
 */
var isNumberLike = function isNumberLike(number) {
  return Number.isFinite(parseFloat(number, 10));
};

/**
 * 转化为数字
 * @param {any} numberStr - 传入的参数
 */
var toNumber = function toNumber(numberStr) {
  return parseFloat(numberStr, 10);
};

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setGlobalConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGlobalConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setTplCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTplCache; });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/**
 * 全局配置工具
 * 
 * @module GlobalConfig
 */

/**
 * 全局配置文件
 * 
 * @namespace config
 */
var GLOBAL_CONFIG = {

  /**
   * 是否开启layout任务切片，开启后有助于提升fps，但会出现渐进渲染效果（一个一个出现）
   * 
   * @memberof config
   */
  shouldSplitLayoutTask: true,

  /**
   * 是否开启linearLayout hack
   * hack主要为了解决两个问题，这个是flexbox无法完整模拟的：
   * 1. 宽度为0的子元素，不占位；如已经为不可见元素，则不添加
   * 2. match_parent hack: 如果 子view 绝对外层宽度大于或等于layout宽度，则增加宽度自动缩放
   * 
   * @memberof config
   */
  shouldExecLinearLayoutHack: true,

  /**
   * 强制使用 pc 模式
   * 部分 windows 设备 gesture 组件有问题，通过开关绕过
   */
  forcePcMode: false,

  /**
   * 关闭事件绑定，业务层自己处理
   * 千牛 pc 场景，将 dx 渲染结果通过 html 字符串缓存
   */
  disableEventBinding: false,

  /**
   * 图片不做优化，使用原图
   */
  forceOriginalImg: false,

  /**
   * 模版延迟渲染
   */
  enableLazyload: false,

  /**
   * 自动化测试模式，需要增加一些无障碍字段标识
   */
  autotestMode: false,

  /**
   * 不使用模版的 localstorage 缓存
   */
  disableTplCache: false,

  /**
   * 关闭 textview 的 linebreakmode: char 的字符截断功能
   */
  disableCharBreak: false,

  /**
   * 部分浏览器内核（钉钉），whitespace: pre 仍然会换行，不符合规范
   * 通过此开关，强制使用 nowrap 代替 pre
   */
  forceNowrap1Line: false,

  /**
   * 性能埋点采样率
   */
  perfTrackerRatio: 0.01,

  /**
   * 在支持 css grid 的设备上，优先使用 grid 实现的 FrameLayout 等基础布局
   * chrome57+，android 8.0+，ios10+
   */
  enableLayoutNG: false,

  /**
   * view、parser 缺失、模版下载失败等错误默认抛给 window.onerror
   * 考虑到 jserror 治理，提供此开关，将错误上报到业务监控而不是 jserror
   */
  catchSDKJSError: false
};

var setGlobalConfig = function setGlobalConfig(key, value) {
  if (key === 'enableLazyload') {
    if (!('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
      return;
    }
  }

  // 值应该在 0 ~ 1 范围内
  if (key === 'perfTrackerRatio') {
    if (typeof value !== 'number' || value > 1 || value < 0) {
      _utils__WEBPACK_IMPORTED_MODULE_0__["log"].warn('Invalid GlobalConfig, perfTrackerRatio should be 0 ~ 1');
      return;
    }
  }

  if (key === 'enableLayoutNG') {
    if (_typeof(document.documentElement.style.grid) === undefined) {
      return;
    }
  }

  GLOBAL_CONFIG[key] = value;
};

var getGlobalConfig = function getGlobalConfig(key) {
  return GLOBAL_CONFIG[key];
};

/**
 * 模版缓存
 */
var TPL_CACHE = {};

var setTplCache = function setTplCache(key, value) {
  if (TPL_CACHE[key]) {
    console.warn('Rewrite tpl cache [' + key + ']');
  }

  TPL_CACHE[key] = value;
};

var getTplCache = function getTplCache(key) {
  var tpl = TPL_CACHE[key];

  if (tpl && typeof tpl === 'string') {
    try {
      tpl = JSON.parse(tpl);
    } catch (e) {
      console.warn(e);
    }
  }

  return tpl;
};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ERROR_TEMPLATE_RENDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ERROR_TEMPLATE_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ERROR_TEMPLATE_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ERROR_TEMPLATE_URL_PROCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR_DATA_PARSER_GEN_AST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ERROR_DATA_PARSER_PARSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ERROR_STORAGE_IDB_GET_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ERROR_STORAGE_IDB_SET_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ERROR_STORAGE_LS_GET_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ERROR_STORAGE_LS_SET_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ERROR_VIEW_404; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ERROR_PARSER_404; });
/**
 * 内置常量表
 * 
 * @inner
 * @module Constant
 */

/** 模版-渲染错误 */
var ERROR_TEMPLATE_RENDER = 'template-render';

/** 模版-下载错误 */
var ERROR_TEMPLATE_DOWNLOAD = 'template-download';

/** 模版内容解析错误，模版为空 */
var ERROR_TEMPLATE_CONTENT = 'template-content';

/** 模版-URL解析错误 */
var ERROR_TEMPLATE_URL_PROCESS = 'template-url-process';

/** 表达式-AST构建错误 */
var ERROR_DATA_PARSER_GEN_AST = 'data-parser-gen-ast';

/** 表达式-解析错误 */
var ERROR_DATA_PARSER_PARSE = 'data-parser-parse';

/** 存储-indexedDB-获取缓存的模版列表错误 */
var ERROR_STORAGE_IDB_GET_MAP = 'storage-idb-get-map';

/** 存储-indexedDB-设置模版列表缓存错误 */
var ERROR_STORAGE_IDB_SET_MAP = 'storage-idb-set-map';

/** 存储-localstorage-获取缓存的模版列表错误 */
var ERROR_STORAGE_LS_GET_MAP = 'storage-ls-get-map';

/** 存储-localstorage-设置模版列表缓存错误 */
var ERROR_STORAGE_LS_SET_MAP = 'storage-ls-set-map';

/** 组件不存在 */
var ERROR_VIEW_404 = 'view-404';

/** parser 不存在 */
var ERROR_PARSER_404 = 'parser-404';

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GLOBAL_CACHE_MAP = {};

var BaseCache = function () {
  function BaseCache(name) {
    _classCallCheck(this, BaseCache);

    this.cache = {};
  }

  _createClass(BaseCache, [{
    key: "set",
    value: function set(key, val) {
      this.cache[key] = val;
      return this;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.cache[key];
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.cache;
    }
  }]);

  return BaseCache;
}();

;

/* harmony default export */ __webpack_exports__["a"] = (function (key) {
  return GLOBAL_CACHE_MAP[key] || (GLOBAL_CACHE_MAP[key] = new BaseCache(key));
});

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var JS_TRACKER_URL = 'dinamicx';
/**
 * 目前Error模块暂定依赖jsTracker，若jsTracker不存在，仍可以使用addErrorListener方法来监听组件报错信息
 */

var Tracker = function () {
  function Tracker() {
    _classCallCheck(this, Tracker);

    this.errorCallback = [];
    this.defaultReport = true;
    this.extraInfo = '';
    if (window.JSTracker2) {
      this.jsTracker = new JSTracker2.constructor({});
    }
  }

  /**
   * 自定义上报信息
   * @param {String} extraInfo - 全局附加上报信息
   * @param {Boolean} defaultReport - 是否开启默认上报
   */


  _createClass(Tracker, [{
    key: 'config',
    value: function config(_ref) {
      var _ref$extraInfo = _ref.extraInfo,
          extraInfo = _ref$extraInfo === undefined ? '' : _ref$extraInfo,
          _ref$defaultReport = _ref.defaultReport,
          defaultReport = _ref$defaultReport === undefined ? true : _ref$defaultReport;

      if (typeof extraInfo !== 'string') {
        return _index__WEBPACK_IMPORTED_MODULE_0__["log"].error('extraInfo must be string!');
      }
      this.extraInfo = extraInfo;
      this.defaultReport = defaultReport;
    }

    /**
     * 上报错误信息，并触发额外监听，由于jsTracker只接受string，因此stringfy后传入，后续处理再行在odps中解析
     * @param {Error} error - 原始错误对象
     * @param {Object.<string, string>} options - 额外信息对象
     */

  }, {
    key: 'report',
    value: function report(error) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.defaultReport && this.jsTracker) {
        var errorType = options && options.type || 'default';
        var reportModule = 'dinamicx/' + errorType;

        var msg = _extends({}, options, {
          error: error && error.message || error,
          extraInfo: ''
        });

        var customUrl = '/dinamicx/' + errorType;
        try {
          customUrl = '' + location.origin + location.pathname + customUrl;
        } catch (e) {
          console.error(e);
        }

        // if (this.jsTracker.reportCustom) {
        //   this.jsTracker.reportCustom({
        //     code: `dx-${errorType}`,
        //     message: JSON.stringify(msg),
        //     success: false,
        //     sampling: 10,
        //   });
        // }

        this.jsTracker.push({
          type: 'error',
          url: customUrl,
          sampling: 10,
          message: JSON.stringify(msg),
          stack: error && error.stack
        });
      }
      this.errorCallback.forEach(function (callback) {
        callback(error, options);
      });
    }

    /**
     * 数据埋点
     * 
     * @param {string} type - 数据类型
     * @param {Object.<string, string>|string} msg - 消息内容
     * @param {Object.<string, string>} options - 消息内容
     */

  }, {
    key: 'log',
    value: function log(type, msg) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // utils.log.warn(`send log - [${type}]`, msg, options);

      if (this.defaultReport && this.jsTracker) {
        this.jsTracker.push(_extends({
          // url: JS_TRACKER_URL + '/log/' + type,
          module: type,
          msg: JSON.stringify(msg),
          sampling: 100
        }, options));
      }
    }

    /**
     * 自行捕获组件报错
     * @param {Function} callback - 回调函数
     */

  }, {
    key: 'addErrorListener',
    value: function addErrorListener(callback) {
      if (typeof callback !== 'function') {
        return _index__WEBPACK_IMPORTED_MODULE_0__["log"].error('callback must be function!');
      }
      this.errorCallback.push(callback);
    }
  }]);

  return Tracker;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Tracker());

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return idb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isIndexedDBValid; });
function getIDB() {
  /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
  try {
    if (typeof window.indexedDB !== 'undefined') {
      return window.indexedDB;
    }
    if (typeof window.webkitIndexedDB !== 'undefined') {
      return window.webkitIndexedDB;
    }
    if (typeof window.mozIndexedDB !== 'undefined') {
      return window.mozIndexedDB;
    }
    if (typeof window.OIndexedDB !== 'undefined') {
      return window.OIndexedDB;
    }
    if (typeof window.msIndexedDB !== 'undefined') {
      return window.msIndexedDB;
    }
  } catch (e) {
    return false;
  }
}

var idb = getIDB();

function isIndexedDBValid() {
  try {
    if (!idb) {
      return false;
    }
    var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

    var hasFetch = typeof fetch === 'function';

    return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' && typeof IDBKeyRange !== 'undefined';
  } catch (e) {
    return false;
  }
}



/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * DinamicX 模版本地缓存管理 - LocalStorage
 * 
 * @module Storage/LocalStorage
 */




/* ------------------------------------------------------------ */

var storage = {
  getItem: function getItem() {},
  setItem: function setItem() {}
};

try {
  // 禁用 cookie 或 storage 时可能报错，SecurityError The operation is insecure
  storage = window.localStorage;
} catch (e) {
  // noop
}

function getItem(key) {
  try {
    var result = storage.getItem(key);

    if (result) {
      result = JSON.parse(result);

      if (result.t === 'object') {
        return JSON.parse(result.v);
      } else {
        return result.v;
      }
    }

    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
}

function setItem(key, value) {
  try {
    if (_utils__WEBPACK_IMPORTED_MODULE_0__["isPlainObject"](value)) {
      storage.setItem(key, JSON.stringify({
        t: 'object',
        v: JSON.stringify(value)
      }));
    } else {
      storage.setItem(key, JSON.stringify({
        t: typeof value === 'undefined' ? 'undefined' : _typeof(value),
        v: value
      }));
    }
  } catch (e) {
    console.error(e);
  }
}

/* ------------------------------------------------------------ */

var TPLNAMELIST_STORE_KEY = 'tpl$TplNameList';

/**
 * @typedef TemplateInfo - 模版信息
 * @type {Object}
 * @property {string} name    - 模版名称
 * @property {string} content - 模版内容
 * @property {string} version - 模版版本
 */

/**
 * ls 设置模版缓存列表，覆盖式增量添加
 * 
 * @static
 * @param {Object.<string, TemplateInfo>} tplMap - 模版缓存列表
 */
var setTemplateMap = function setTemplateMap(tplMap) {
  try {
    var tplNameList = getItem(TPLNAMELIST_STORE_KEY);

    if (tplNameList) {
      tplNameList = tplNameList.split('$');
    } else {
      tplNameList = [];
    }

    _utils__WEBPACK_IMPORTED_MODULE_0__["mapValue"](tplMap, function (tpl) {
      var name = tpl.name;

      setItem('tpl-' + name, tpl);

      tplNameList.push(name);
    });

    // 缓存模版名称列表
    setItem(TPLNAMELIST_STORE_KEY, tplNameList.join('$'));
  } catch (e) {
    _utils__WEBPACK_IMPORTED_MODULE_0__["log"].error(e, {
      type: _constant__WEBPACK_IMPORTED_MODULE_1__[/* ERROR_STORAGE_LS_SET_MAP */ "g"]
    });
  }

  return Promise.resolve([]);
};

/**
 * ls 获取模版缓存列表
 * 
 * @static
 * @returns {TemplateInfo} - 模版缓存列表 
 */
var getTemplateMap = function getTemplateMap() {
  var tplMap = {};
  try {
    var tplNameList = getItem(TPLNAMELIST_STORE_KEY);

    if (tplNameList) {
      tplNameList = tplNameList.split('$');

      tplNameList.forEach(function (tplName) {
        var tpl = getItem('tpl-' + tplName);

        tplMap[tplName] = tpl;
      });
    }
  } catch (e) {
    _utils__WEBPACK_IMPORTED_MODULE_0__["log"].error(e, {
      type: _constant__WEBPACK_IMPORTED_MODULE_1__[/* ERROR_STORAGE_LS_GET_MAP */ "f"]
    });
  }

  return Promise.resolve(tplMap);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  setTemplateMap: setTemplateMap,
  getTemplateMap: getTemplateMap
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _utils_indexedDB__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);
/**
 * DinamicX 模版本地缓存管理 - indexedDB
 * 
 * @module Storage/IndexedDB
 */






var OBJECT_STORE_NAME = 'template';

var dinamicDB = _utils_indexedDB__WEBPACK_IMPORTED_MODULE_1__[/* idb */ "a"].open('DinamicX', 2);

var dbReady = new Promise(function (resolve) {
  dinamicDB.onupgradeneeded = function (event) {
    var db = dinamicDB.result;
    var transaction = event.target.transaction;
    db.createObjectStore(OBJECT_STORE_NAME, { keyPath: 'name' });

    transaction.oncomplete = function () {
      return resolve(db);
    };
  };

  dinamicDB.onsuccess = function () {
    return resolve(dinamicDB.result);
  };
});

// indexedDB的任务处理函数
var idbRequestWrapper = function idbRequestWrapper(request) {
  return new Promise(function (resolve, reject) {
    request.onsuccess = resolve;
    request.onerror = reject;
  });
};

var getObjectStore = function getObjectStore(db) {
  return db.transaction(OBJECT_STORE_NAME, 'readwrite').objectStore(OBJECT_STORE_NAME);
};

/* ------------------------------------------------------------ */

/**
 * @typedef TemplateInfo - 模版信息
 * @type {Object}
 * @property {string} name    - 模版名称
 * @property {string} content - 模版内容
 * @property {string} version - 模版版本
 */

/**
 * idb 设置模版缓存列表，覆盖式增量添加
 * 
 * @static
 * @param {Object.<string, TemplateInfo>} tplMap - 模版缓存列表
 */
var setTemplateMap = function setTemplateMap(tplMap) {
  return dbReady.then(function (db) {
    var store = getObjectStore(db);
    var asyncTasks = [];

    _utils__WEBPACK_IMPORTED_MODULE_0__["mapValue"](tplMap, function (tpl) {
      asyncTasks.push(idbRequestWrapper(store.put(tpl)).catch(function (e) {
        _utils__WEBPACK_IMPORTED_MODULE_0__["log"].error(e, {
          type: _constant__WEBPACK_IMPORTED_MODULE_2__[/* ERROR_STORAGE_IDB_SET_MAP */ "e"],
          templateName: tpl.name,
          templateVersion: tpl.version
        });
      }));
    });

    return Promise.all(asyncTasks);
  });
};

/**
 * idb 获取模版缓存列表
 * 
 * @static
 * @returns {TemplateInfo} 模版缓存列表 
 */
var getTemplateMap = function getTemplateMap() {
  return dbReady.then(function (db) {
    var store = getObjectStore(db);
    var request = store.openCursor();

    return new Promise(function (resolve, reject) {
      var tplMap = {};

      request.onsuccess = function (event) {
        var cursor = event.target.result;

        if (cursor) {
          var tpl = cursor.value;
          tplMap[tpl.name] = tpl;

          cursor.continue();
        } else {
          resolve(tplMap);
        }
      };

      request.onerror = reject;
    }).catch(function (e) {
      _utils__WEBPACK_IMPORTED_MODULE_0__["log"].error(e, {
        type: _constant__WEBPACK_IMPORTED_MODULE_2__[/* ERROR_STORAGE_IDB_GET_MAP */ "d"]
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  setTemplateMap: setTemplateMap,
  getTemplateMap: getTemplateMap
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var perf_tracker_namespaceObject = {};
__webpack_require__.r(perf_tracker_namespaceObject);
__webpack_require__.d(perf_tracker_namespaceObject, "TPL_INIT", function() { return TPL_INIT; });
__webpack_require__.d(perf_tracker_namespaceObject, "TPL_DID_MOUNT", function() { return TPL_DID_MOUNT; });
__webpack_require__.d(perf_tracker_namespaceObject, "TPL_LOAD_LOCAL", function() { return TPL_LOAD_LOCAL; });
__webpack_require__.d(perf_tracker_namespaceObject, "TPL_LOAD_REMOTE", function() { return TPL_LOAD_REMOTE; });
__webpack_require__.d(perf_tracker_namespaceObject, "BEFORE_CREATE_VDOM", function() { return BEFORE_CREATE_VDOM; });
__webpack_require__.d(perf_tracker_namespaceObject, "AFTER_CREATE_VDOM", function() { return AFTER_CREATE_VDOM; });
__webpack_require__.d(perf_tracker_namespaceObject, "TPL_LAYOUT", function() { return TPL_LAYOUT; });
__webpack_require__.d(perf_tracker_namespaceObject, "init", function() { return perf_tracker_init; });
__webpack_require__.d(perf_tracker_namespaceObject, "mark", function() { return mark; });
__webpack_require__.d(perf_tracker_namespaceObject, "report", function() { return perf_tracker_report; });

// EXTERNAL MODULE: external {"amd":"react","commonjs":"react","commonjs2":"react","root":"React"}
var external_amd_react_commonjs_react_commonjs2_react_root_React_ = __webpack_require__(4);

// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(0);

// EXTERNAL MODULE: ./src/utils/cache.js
var utils_cache = __webpack_require__(3);

// EXTERNAL MODULE: ./src/utils/tracker.js
var tracker = __webpack_require__(5);

// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(1);

// CONCATENATED MODULE: ./src/utils/perf-tracker.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var supportPerformanceAPI = window.performance && window.performance.mark && window.performance.measure;

var CACHE = {};

function generateMarkKey(prefix, name) {
  return prefix + '_' + name;
}

function generateMeasureKey(base) {
  return base + '_measure';
}

function hasMark(markKey) {
  var res = window.performance.getEntriesByName(markKey);
  return Boolean(res.length);
}

function calcMeasureDuration(measureKey) {
  var duration = 0;

  var res = window.performance.getEntriesByName(measureKey);
  if (res.length) {
    duration = parseInt(Number(res[0].duration));
    window.performance.clearMeasures(measureKey);
  }

  return duration;
}

var TPL_INIT = 0;
// 有模版缓存的情况，didmoount 是所有节点 mount 完成时间，再加上布局时间就是模版渲染稳定时间（包含重排引起的抖动）
// 无缓存情况，需要异步下载模版，didmount 很短，不具参考意义
var TPL_DID_MOUNT = 1;
// 本地缓存读取模版
var TPL_LOAD_LOCAL = 2;
// 远程下载模版
var TPL_LOAD_REMOTE = 3;
var BEFORE_CREATE_VDOM = 4.1;
var AFTER_CREATE_VDOM = 4.2;
var TPL_LAYOUT = 5;

/**
 * 模版性能采样，采样规则：
 *    1. 页面有 jstracker
 *    2. 默认 5% 抽样
 *    3. 性能开关调整采样率，用于调试
 * @return null | string
 */
var perf_tracker_init = function init() {
  var perfTrackerRatio = Object(config["a" /* getGlobalConfig */])('perfTrackerRatio');
  // 避免 random 为 0，要用此随机值作为当前模版 uuid，
  var randomN = Math.random() + 1e-8;

  if (!(supportPerformanceAPI && tracker["a" /* default */].jsTracker && randomN < perfTrackerRatio)) {
    return;
  }

  // 3s 后自动上报
  setTimeout(function () {
    perf_tracker_report(randomN);
  }, 3000);

  return String(randomN);
};

var mark = function mark(prefix, name, extraInfo) {
  if (!prefix) return;

  window.performance.mark(generateMarkKey(prefix, name));

  // 扩展信息，存储当前模版相关信息等
  if (extraInfo) {
    CACHE[prefix] = _extends({}, CACHE[prefix], extraInfo);
  }
};

var perf_tracker_report = function report(prefix) {
  if (!prefix) return;

  var perfInfo = {
    localLoadTime: 0,
    remoteLoadTime: 0,
    vdomCreateTime: 0,
    mountTime: 0,
    layoutTime: 0,
    layoutCount: 0,
    fullTime: 0
  };

  var initKey = generateMarkKey(prefix, TPL_INIT);
  var loadLocalKey = generateMarkKey(prefix, TPL_LOAD_LOCAL);
  var loadRemoteKey = generateMarkKey(prefix, TPL_LOAD_REMOTE);
  var beforeVdomCreateKey = generateMarkKey(prefix, BEFORE_CREATE_VDOM);
  var afterVdomCreateKey = generateMarkKey(prefix, AFTER_CREATE_VDOM);
  var vdomMeasureKey = generateMarkKey(prefix, 'measureVdom');
  var didMountKey = generateMarkKey(prefix, TPL_DID_MOUNT);
  var layoutKey = generateMarkKey(prefix, TPL_LAYOUT);

  if (hasMark(initKey) && hasMark(loadLocalKey)) {
    var measureKey = generateMeasureKey(loadLocalKey);
    window.performance.measure(measureKey, initKey, loadLocalKey);
    perfInfo.localLoadTime = calcMeasureDuration(measureKey);
  }
  if (hasMark(initKey) && hasMark(loadRemoteKey)) {
    var _measureKey = generateMeasureKey(loadRemoteKey);
    window.performance.measure(_measureKey, initKey, loadRemoteKey);
    perfInfo.remoteLoadTime = calcMeasureDuration(_measureKey);
  }
  if (hasMark(beforeVdomCreateKey) && hasMark(afterVdomCreateKey)) {
    var _measureKey2 = generateMeasureKey(afterVdomCreateKey);
    window.performance.measure(_measureKey2, beforeVdomCreateKey, afterVdomCreateKey);
    perfInfo.vdomCreateTime = calcMeasureDuration(_measureKey2);
  }
  if (hasMark(initKey) && hasMark(didMountKey)) {
    var _measureKey3 = generateMeasureKey(didMountKey);
    window.performance.measure(_measureKey3, initKey, didMountKey);
    perfInfo.mountTime = calcMeasureDuration(_measureKey3);
  }
  if (hasMark(didMountKey) && hasMark(layoutKey)) {
    var _measureKey4 = generateMeasureKey(layoutKey);
    window.performance.measure(_measureKey4, didMountKey, layoutKey);
    perfInfo.layoutTime = calcMeasureDuration(_measureKey4);
    perfInfo.layoutCount = window.performance.getEntriesByName(layoutKey).length;
  }

  // layout 的 mark 可能不存在，通过 didmount + layout 计算出 dom 渲染稳定的耗时
  perfInfo.fullTime = perfInfo.mountTime + perfInfo.layoutTime;

  // console.log(perfInfo, CACHE[prefix]);
  tracker["a" /* default */].log('perf', _extends({}, perfInfo, CACHE[prefix]), {
    sampling: 1,
    url: 'dinamicx/perf'
  });

  delete CACHE[prefix];
  window.performance.clearMarks(initKey);
  window.performance.clearMarks(didMountKey);
  window.performance.clearMarks(beforeVdomCreateKey);
  window.performance.clearMarks(afterVdomCreateKey);
  window.performance.clearMarks(loadLocalKey);
  window.performance.clearMarks(loadRemoteKey);
  window.performance.clearMarks(layoutKey);
};
// EXTERNAL MODULE: ./src/utils/indexedDB.js
var indexedDB = __webpack_require__(6);

// EXTERNAL MODULE: ./src/constant.js
var constant = __webpack_require__(2);

// CONCATENATED MODULE: ./src/downloader.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var downloader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * DinamicX 模版管理
 *
 * @module Downloader
 */







var readDXStorage = function readDXStorage() {
  return storage.getTemplateMap().then(function (tplMap) {
    return Object.assign(STORAGE_TEMPLATE, tplMap);
  });
};

var initLocalStorage = function initLocalStorage() {
  storage = __webpack_require__(8).default;
  STORAGE_READY = readDXStorage();
};

var downloader_initIndexedDB = function initIndexedDB() {
  if (Object(indexedDB["b" /* isIndexedDBValid */])()) {
    storage = __webpack_require__(9).default;
    STORAGE_READY = readDXStorage();
  } else {
    utils["log"].warn('当前设备不支持 indexedDB');
  }
};

var storage = void 0,
    STORAGE_READY = void 0;
initLocalStorage();

/**
 * @typedef CacheTemplateInfo
 * @type {Object}
 * @property {string} name - 模版名称
 * @property {string} content - 模版内容
 * @property {string} version - 模版版本
 */

/**
 * 做全局缓存和当前队列缓存
 * @type {Object.<string, CacheTemplateInfo>}
 */
var STORAGE_TEMPLATE = {};

// 3+ 新版 ossgw 地址，共分三个状态
var REG_TPL3_URL = /rapid-oss-bucket\/?(publish|debug|preview)?\/(\d+)\/(.*?)\.(?:js|zip)/;
var REG_TPL4_URL = /dinamicx.alibabausercontent.com\/?(.*)?\/.*?\/(\d+)\/(.*?)\.(?:js|zip)/;
var REG_TPL_URL = /\/(?:v-)?(\d+)\/(.*?)_(h5|ios|android)\.(?:plist|js|xml)/;
var REG_ULTRON_DEV_TPL_URL = /\ultronage.*\/dinamicx\/(.*?)\/(\d+)\/(h5|ios|android).*/i;

var ULTRON_DEV_TYPE = 'ultron_dev';

/* ------------------------------------------------------------ */

// 全局模版容器
var d_tpl = window.d_tpl = window.d_tpl || {};

/**
 * @typedef ProcessedTemplateInfo
 * @type {Object}
 * @property {string} url  - 模版url
 * @property {string} name - 模版名称
 * @property {string} version - 模版版本号
 * @property {string} env - 模版环境（>3.0.0 才有）
 * @property {boolean} shouldCombo - url是否需要combo
 */

/**
 * 解析模版url
 *
 * @param {string} url - 模版url
 * @returns {ProcessedTemplateInfo} 模版解析结果
 *
 */
function _processTplUrl(url) {
  var matchTpl3 = REG_TPL3_URL.exec(url);
  var matchTpl4 = REG_TPL4_URL.exec(url);
  var matchUltronDevTpl = REG_ULTRON_DEV_TPL_URL.exec(url);

  if (matchTpl3) {
    var _matchTpl = _slicedToArray(matchTpl3, 4),
        _matchTpl$ = _matchTpl[1],
        env = _matchTpl$ === undefined ? '' : _matchTpl$,
        tplVersion = _matchTpl[2],
        tplName = _matchTpl[3];

    var type = 'h5_3+';
  } else if (matchTpl4) {
    var _matchTpl2 = _slicedToArray(matchTpl4, 4),
        _matchTpl2$ = _matchTpl2[1],
        env = _matchTpl2$ === undefined ? '' : _matchTpl2$,
        tplVersion = _matchTpl2[2],
        tplName = _matchTpl2[3];

    var type = 'h5_4+';
    /**
     * 恶心的路径兼容，模版名可能加 _h5 后缀
     * https://dinamicx.alibabausercontent.com/pub/ww_card_xunjiadan/1632281613712/ww_card_xunjiadan.js
     * https://dinamicx.alibabausercontent.com/pub/pe_common_card/1607677472274/pe_common_card_h5.js
     */
    var h5_4plus_filename = tplName;
    tplName = tplName.replace(/_h5$/, '');
  } else if (matchUltronDevTpl) {
    var _matchUltronDevTpl = _slicedToArray(matchUltronDevTpl, 3),
        tplName = _matchUltronDevTpl[1],
        tplVersion = _matchUltronDevTpl[2];

    var type = ULTRON_DEV_TYPE;
  } else {
    var match = REG_TPL_URL.exec(url);

    if (match) {
      var _match = _slicedToArray(match, 4),
          tplVersion = _match[1],
          tplName = _match[2],
          type = _match[3];
    } else {
      throw new Error('Fail to parse template url: ' + url);
    }
  }

  /* ------------------------------------------------------------ */

  var result = {
    name: tplName,
    version: tplVersion,
    env: env,
    type: type
  };

  if (type === 'h5_3+') {
    result.url = 'https://ossgw.alicdn.com/rapid-oss-bucket/' + env + '/' + tplVersion + '/' + tplName + '.js';
  } else if (type === "h5_4+") {
    result.url = 'https://dinamicx.alibabausercontent.com/' + env + '/' + tplName + '/' + tplVersion + '/' + h5_4plus_filename + '.js';
  } else if (type === 'h5') {

    // 只有g.alicdn支持combo，ossgw不支持
    if (utils["includes"](url, 'g.alicdn')) {
      result.shouldCombo = true;
      result.url = tplName + '/' + tplVersion + '/' + tplName + '_h5.js';
    } else {
      result.url = url;
    }
  } else if (type === ULTRON_DEV_TYPE) {
    result.url = 'https://pre-ultronage3.alibaba-inc.com/gw/nobuc/v3/Dinamicx/' + tplName + '/' + tplVersion + '/h5/getCdn.js';
  } else {
    if (tplName && tplVersion) {
      result.url = 'https://ossgw.alicdn.com/rapid-oss-bucket/template_online/' + tplName + '/' + tplVersion + '/' + tplName + '_h5.js';
    }
  }

  return result;
}

/**
 * 返回值结构控制
 */
function downloadResultWrapper(template, content) {
  var useCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var perfKey = useCache ? TPL_LOAD_LOCAL : TPL_LOAD_REMOTE;
  mark(template.perfTrackerPrefix, perfKey, {
    name: template.name,
    version: template.version,
    length: JSON.stringify(content).length,
    useCache: useCache
  });

  return {
    template: template,
    tplNodeTree: content
  };
}

/**
 * 获取下载完成的模版
 *
 * @param {string} tplName - 模版名称
 */
function downloadTplContentProcess(template, curQueueTplMap) {
  var name = template.name;
  var content = d_tpl[name];

  if (content) {
    STORAGE_TEMPLATE[name] = curQueueTplMap[name] = {
      name: name,
      content: content,
      version: template.version
    };
  } else {
    utils["log"].error('empty template content', {
      type: constant["h" /* ERROR_TEMPLATE_CONTENT */],
      templateName: name
    }, true);
  }

  return downloadResultWrapper(template, content, false);
}

/* ------------------------------------------------------------ */
var QUEUE = [];
var QUEUE_CACHE = {};

function startDownload() {

  // 当前队列下载的模版列表
  var curQueueTplMap = {};

  // 可combo模版列表
  var comboList = [];

  var queueProcess = function queueProcess(tplStorage) {
    return Promise.all(QUEUE.map(function (template) {
      var url = template.url,
          name = template.name,
          version = template.version,
          shouldCombo = template.shouldCombo,
          onFinish = template.onFinish,
          onError = template.onError,
          type = template.type;

      var tplContentStore = tplStorage[name];
      var useTplCache = !(type === ULTRON_DEV_TYPE || Object(config["a" /* getGlobalConfig */])('disableTplCache'));

      // 只有版本相同时才用缓存
      if (useTplCache && tplContentStore && tplContentStore.version == version) {

        // 有缓存直接使用，触发成功回掉
        onFinish(downloadResultWrapper(template, tplContentStore.content));
      } else {

        // 无缓存，启动下载
        if (shouldCombo) {
          comboList.push(template);
        } else {
          return utils["addScript"](url).then(function () {

            // 数据埋点，成功下载量记录
            utils["sendRateLog"]('download', true, {
              templateUrl: url
            });

            return downloadTplContentProcess(template, curQueueTplMap);
          }).then(function (resultData) {
            return onFinish(resultData);
          }).catch(function (err) {
            utils["log"].error(err, {
              type: constant["i" /* ERROR_TEMPLATE_DOWNLOAD */],
              templateUrl: url
            });

            // 数据埋点，失败下载量记录
            utils["sendRateLog"]('download', false, {
              templateUrl: url
            });

            onError(err);
          });
        }
      }
    }));
  };

  var comboDownload = function comboDownload() {
    if (comboList.length > 0) {
      var comboUrl = 'https://g.alicdn.com/code/dinamic-publish/??' + comboList.map(function (template) {
        return template.url;
      }).join(',');
      return utils["addScript"](comboUrl).then(function () {
        comboList.forEach(function (template) {

          // 数据埋点，成功下载量记录
          utils["sendRateLog"]('download', true, {
            templateUrl: template.url
          });

          var resultData = downloadTplContentProcess(template, curQueueTplMap);

          template.onFinish(resultData);
        });
      }).catch(function (err) {
        utils["log"].error(err, {
          type: constant["i" /* ERROR_TEMPLATE_DOWNLOAD */],
          templateUrl: comboUrl
        });

        comboList.forEach(function (template) {

          // 数据埋点，失败下载量记录
          utils["sendRateLog"]('download', false, {
            templateUrl: template.url
          });

          template.onError(err);
        });
      });
    }
  };

  // 队列开始下载
  // 1. 首先开始队列下载，如果是普通url直接下载
  // 2. comboUrl的话会缓存起来，组合起来下载
  return STORAGE_READY.then(queueProcess).then(comboDownload).then(function () {
    return storage.setTemplateMap(curQueueTplMap);
  });
}

/**
 * 过滤并启动下载队列
 * @param {ProcessedTemplateInfo} template - 即将下载的模版
 */
function filterAndCacheQueue(template) {

  // 过滤队列, 判断当前模版是否本次队列已经下载，如果已经下载，则跳过
  var cacheKey = template.name;

  var _ref = QUEUE_CACHE[cacheKey] || {},
      cacheVersion = _ref.version,
      cacheDownloadTask = _ref.downloadTask;

  if (cacheVersion == template.version) {
    return cacheDownloadTask;
  }

  /* ------------------------------------------------------------ */
  /* 缓存下载任务 */

  var downloadTask = new Promise(function (resolve, reject) {
    QUEUE.push(downloader_extends({
      onFinish: resolve,
      onError: reject
    }, template));
  });

  QUEUE_CACHE[cacheKey] = {
    version: template.version,
    downloadTask: downloadTask
  };

  return downloadTask;
}

/**
 * 清理队列
 */
function clearQueue() {
  QUEUE = [];
  QUEUE_CACHE = {};
}

/**
 * 启动下载队列
 */
var startQueue = function () {
  var timerId = void 0;

  return function () {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = window.setTimeout(function () {
      startDownload().then(function () {
        return clearQueue();
      });
    }, 0);
  };
}();

/**
 * 模版下载管理
 * 支持 DinamicX 模版平台生成的 g.alicdn.com 和 ossgw.alicdn.com 域名的地址
 * 支持 UrlCombo，队列管理等功能
 * @class
 */

var downloader_Downloader = function () {
  function Downloader() {
    _classCallCheck(this, Downloader);
  }

  _createClass(Downloader, null, [{
    key: 'add',


    /**
     * 增加一个模版到下载队列并立即开始下载
     * @param {string} url - 模版url
     */
    value: function add(url, perfTrackerPrefix) {

      var template = Downloader.processTplUrl(url);

      var tplCache = Object(config["b" /* getTplCache */])(url);
      if (tplCache && tplCache.content) {
        return Promise.resolve(downloadResultWrapper(template, tplCache.content));
      }

      if (template) {
        template.perfTrackerPrefix = perfTrackerPrefix;

        return STORAGE_READY.then(function (tplStorage) {
          // 前置判断缓存
          var name = template.name,
              version = template.version,
              type = template.type;

          // 不用缓存

          if (type === ULTRON_DEV_TYPE || Object(config["a" /* getGlobalConfig */])('disableTplCache')) {
            tplStorage = {};
          }

          var cacheTpl = tplStorage[name];
          if (cacheTpl && cacheTpl.version == version) {
            return downloadResultWrapper(template, cacheTpl.content);
          }

          // 延迟启动下载任务，可以聚合一个tick内的下载任务
          startQueue();

          return filterAndCacheQueue(template);
        });
      } else {
        utils["log"].error('invalid_tpl_url', {
          type: constant["k" /* ERROR_TEMPLATE_URL_PROCESS */],
          templateUrl: url
        });
        return Promise.reject('invalid_tpl_url ' + url);
      }
    }
  }, {
    key: 'processTplUrl',
    value: function processTplUrl(url) {
      var template = void 0;
      try {
        template = _processTplUrl(url);
      } catch (e) {
        utils["log"].warn('tpl url process error', url);
      }

      return template;
    }

    /**
     * 获取模版缓存内容
     * @param {ProcessedTemplateInfo} template - 模版信息
     */

  }, {
    key: 'getCache',
    value: function getCache(template, perfTrackerPrefix) {
      // 不用缓存
      if (template.type === ULTRON_DEV_TYPE || Object(config["a" /* getGlobalConfig */])('disableTplCache')) {
        return null;
      }

      var cacheTpl = STORAGE_TEMPLATE[template.name];
      if (cacheTpl && cacheTpl.version == template.version) {
        mark(perfTrackerPrefix, TPL_LOAD_LOCAL, {
          name: template.name,
          version: template.version,
          length: JSON.stringify(cacheTpl).length,
          useCache: true
        });
        return cacheTpl.content;
      }
    }

    /**
     * 设置模版缓存
     * @param {TemplateInfo[]} tplList - 缓存列表
     */

  }, {
    key: 'setCache',
    value: function setCache(tplList) {
      tplList.forEach(function (_ref2) {
        var name = _ref2.name,
            version = _ref2.version,
            content = _ref2.content;

        STORAGE_TEMPLATE[name] = {
          name: name, version: version, content: content
        };
      });
    }

    /**
     *
     * @param {function} fn - 自定义模版 url processor
     *
     *
     * fn 定义
     *
     * param {string} url - 待处理的模版 url
     *
     * returns {Object} 模版处理结果
     * @property {string} url  - 模版下载地址
     * @property {string} name - 模版名称，模版内容中 d_tpl 的 key 值
     * @property {number} version - 模版版本号
     */

  }, {
    key: 'registerTplUrlProcessor',
    value: function registerTplUrlProcessor(fn) {
      if (typeof fn !== 'function') {
        throw new Error('Invalid Tpl Url Processor');
      } else {
        _processTplUrl = fn;
      }
    }
  }]);

  return Downloader;
}();

/* harmony default export */ var downloader = (downloader_Downloader);
// CONCATENATED MODULE: ./src/ravel.js
var ravel_slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var ravel_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function ravel_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 轻量级的跨组件数据驱动重渲染机制
 * 
 * @module Ravel
 */




var RAVEL_CACHE = Object(utils_cache["a" /* default */])('ravel');

/* ------------------------------------------------------------ */

/**
 * 轻量级的跨组件数据驱动重渲染机制
 * @class
 */

var ravel_Ravel = function () {
  function Ravel() {
    ravel_classCallCheck(this, Ravel);
  }

  ravel_createClass(Ravel, null, [{
    key: 'bind',


    /**
     * 绑定组件关系
     * 
     * @param {Object} context - 目标组件实例上下文
     * @param {string} name - 关系名称
     * @param {Object.<string, string>} relation - 关系描述，prop可以对应目标组件的实例内部变量或者state
     */
    value: function bind(context, name, relation) {
      var prevRelation = RAVEL_CACHE.get(name) || [];

      RAVEL_CACHE.set(name, [[context, relation]].concat(_toConsumableArray(prevRelation)));
    }

    /**
     * 更新数据，并驱动目标组件重渲染
     * @param {string} name - 关系名称
     * @param {Object.<string, string>} dataMap - 数据集合，key对应relation的key，value为需要设置的数据
     */

  }, {
    key: 'setData',
    value: function setData(name, dataMap) {
      var cache = RAVEL_CACHE.get(name);

      if (!cache) {
        console.error('Can\'t find context bind with the name ("' + name + '") !');
      }

      if (Array.isArray(cache)) {
        cache.forEach(function (_ref) {
          var _ref2 = ravel_slicedToArray(_ref, 2),
              ctx = _ref2[0],
              relation = _ref2[1];

          var changeMap = {};

          utils["mapValue"](dataMap, function (value, key) {
            var prop = relation[key];

            if (prop) {

              // 直接参数赋值，用于dinamic属性修改原值
              if (prop in ctx) {
                ctx[prop] = value;
              }

              if (ctx.state && prop in ctx.state) {

                // 缓存更新表，用于解决部分ui框架未提供 setState 批量更新功能
                changeMap[prop] = value;
              }
            }
          });

          if (!utils["isEmpty"](changeMap)) {

            // 如果在state中发现相同key，使用 setState 去触发 ui 更新
            ctx.setState(changeMap);
          } else {

            // 如果未发现相同key, 则直接用 forceUpdate 触发更新
            ctx.forceUpdate();
          }
        });
      }
    }

    /**
     * 获取已经绑定的目标组件实例
     * @param {string} name - 关系名称
     */

  }, {
    key: 'getContext',
    value: function getContext(name) {
      return (RAVEL_CACHE.get(name) || [])[0];
    }
  }]);

  return Ravel;
}();

/* harmony default export */ var ravel = (ravel_Ravel);
// CONCATENATED MODULE: ./src/data-parser/built-in.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var built_in_slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }




/**
 * 内置表达式
 * 支持20余个表达式，同步native支持情况
 * 具体参见：https://yuque.antfin-inc.com/dinamicx/intro/hcgx14
 *
 * @module Built-In-Parsers
 * @example
 *  用法示例：
 *  `<TextView text="@if{@data{a.b}, 'yes', 'no'}">`
 *
 */

var builtInDataParser = {};

var toLikeBoolean = function toLikeBoolean(b) {
  if (b === 'false' || b === false || b === '0' || !b || Array.isArray(b) && b.length === 0) {
    return false;
  }

  return true;
};

var built_in_mathFilter = function mathFilter(mathFun) {
  return function (args) {
    if (args.length === 1 && utils["isNumberLike"](args[0])) {
      return mathFun(args[0]);
    } else {
      return 0;
    }
  };
};

/**
 *
 * @param { function } calculateFun
 */
var built_in_calculateFilter = function calculateFilter(calculateFun) {
  return function (_ref) {
    var _ref2 = built_in_slicedToArray(_ref, 2),
        i1 = _ref2[0],
        i2 = _ref2[1];

    if (utils["isNumberLike"](i1) && utils["isNumberLike"](i2)) {
      return calculateFun([utils["toNumber"](i1), utils["toNumber"](i2)]);
    } else if (utils["isNumberLike"](i1)) {
      return utils["toNumber"](i1);
    } else if (utils["isNumberLike"](i2)) {
      return utils["toNumber"](i2);
    } else {
      return 0;
    }
  };
};

var built_in_divisorZeroFilter = function divisorZeroFilter(calculateFun) {
  return function (_ref3) {
    var _ref4 = built_in_slicedToArray(_ref3, 2),
        i1 = _ref4[0],
        i2 = _ref4[1];

    if (utils["toNumber"](i2) === 0) {
      return 0;
    } else {
      return calculateFun([utils["toNumber"](i1), utils["toNumber"](i2)]);
    }
  };
};
/* ------------------------------------------------------------ */
/* 逻辑操作 */

builtInDataParser.if = function (_ref5) {
  var _ref6 = built_in_slicedToArray(_ref5, 2),
      cond = _ref6[0],
      value = _ref6[1];

  return toLikeBoolean(cond) && value;
};

builtInDataParser.else = function (_ref7) {
  var _ref8 = built_in_slicedToArray(_ref7, 1),
      value = _ref8[0];

  return value;
};

builtInDataParser.not = function (_ref9) {
  var _ref10 = built_in_slicedToArray(_ref9, 1),
      o = _ref10[0];

  return !toLikeBoolean(o);
};

builtInDataParser.and = function (args) {
  return args.reduce(function (o1, o2) {
    return toLikeBoolean(o1) && toLikeBoolean(o2);
  });
};

builtInDataParser.or = function (args) {
  return args.reduce(function (o1, o2) {
    return toLikeBoolean(o1) || toLikeBoolean(o2);
  });
};

builtInDataParser.triple = function (_ref11) {
  var _ref12 = built_in_slicedToArray(_ref11, 3),
      cond = _ref12[0],
      val1 = _ref12[1],
      val2 = _ref12[2];

  return toLikeBoolean(cond) ? val1 : val2;
};

/* ------------------------------------------------------------ */
/* 集合操作 */

builtInDataParser.equal = function (_ref13) {
  var _ref14 = built_in_slicedToArray(_ref13, 2),
      o1 = _ref14[0],
      o2 = _ref14[1];

  return utils["isEqual"](o1, o2);
};

builtInDataParser.array_get = function (_ref15) {
  var _ref16 = built_in_slicedToArray(_ref15, 2),
      arr = _ref16[0],
      index = _ref16[1];

  return !Array.isArray(arr) || isNaN(index) ? null : arr[~~index];
};

builtInDataParser.index_of = function (_ref17) {
  var _ref18 = built_in_slicedToArray(_ref17, 3),
      _ref18$ = _ref18[0],
      arr = _ref18$ === undefined ? [] : _ref18$,
      item = _ref18[1],
      key = _ref18[2];

  if (!Array.isArray(arr)) return null;

  var index = -1;

  if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
    var itemStr = '';
    try {
      itemStr = JSON.stringify(item);
    } catch (e) {
      console.error(e);
    }

    var strArr = [];
    try {
      arr.map(function (obj) {
        strArr.push(JSON.stringify(obj));
      });
    } catch (e) {
      console.error(e);
    }

    index = strArr.indexOf(itemStr);
  } else {
    index = arr.indexOf(item);
  }

  return index === -1 ? null : index;
};
builtInDataParser.array_find = function (_ref19) {
  var _ref20 = built_in_slicedToArray(_ref19, 2),
      arr = _ref20[0],
      obj = _ref20[1];

  if (!Array.isArray(arr)) {
    return null;
  }
  var index = arr.indexOf(obj);
  return index === -1 ? null : arr[index];
};

builtInDataParser.dict_get = function (_ref21) {
  var _ref22 = built_in_slicedToArray(_ref21, 2),
      obj = _ref22[0],
      key = _ref22[1];

  return obj && obj[key];
};

builtInDataParser.data = function (_ref23, templateData) {
  var _ref24 = built_in_slicedToArray(_ref23, 1),
      expression = _ref24[0];

  if (!expression) {
    return templateData;
  }
  return utils["deepGet"](templateData, expression);
};

// data 为 listlayout 的外层data，options.data 才是当前 item 的 data
builtInDataParser.subdata = function (_ref25, data) {
  var _ref26 = built_in_slicedToArray(_ref25, 1),
      exp = _ref26[0];

  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!exp) {
    return options.data;
  }

  return utils["deepGet"](options.data, exp);
};

builtInDataParser.subdataIndex = function (_ref27, data) {
  var _ref28 = built_in_slicedToArray(_ref27, 1),
      exp = _ref28[0];

  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return options.subdataIndex;
};

builtInDataParser.parentSubdata = function (_ref29, data) {
  var _ref30 = built_in_slicedToArray(_ref29, 1),
      exp = _ref30[0];

  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!exp) {
    return options.parentSubdata;
  }

  return utils["deepGet"](options.parentSubdata, exp);
};

/* ------------------------------------------------------------ */
/* 字符串操作 */

builtInDataParser.lowercase = function (_ref31) {
  var _ref32 = built_in_slicedToArray(_ref31, 1),
      str = _ref32[0];

  if (utils["isString"](str)) {
    return str.toLowerCase();
  }

  return str;
};

builtInDataParser.uppercase = function (_ref33) {
  var _ref34 = built_in_slicedToArray(_ref33, 1),
      str = _ref34[0];

  if (utils["isString"](str)) {
    return str.toUpperCase();
  }

  return str;
};

builtInDataParser.substr = function (_ref35) {
  var _ref36 = built_in_slicedToArray(_ref35, 3),
      str = _ref36[0],
      start = _ref36[1],
      len = _ref36[2];

  if (utils["isString"](str)) {

    // hack: native不支持反向截取
    return str.substr(start >= 0 ? start : 0, len);
  }

  return str;
};

builtInDataParser.concat = function (args) {
  return args.reduce(function (s1, s2) {
    return (s1 || '') + (s2 || '');
  });
};

builtInDataParser.trim = function (_ref37) {
  var _ref38 = built_in_slicedToArray(_ref37, 1),
      str = _ref38[0];

  if (utils["isString"](str)) {
    return str.trim();
  }

  return str;
};

/* ------------------------------------------------------------ */
/* 数字操作 */

builtInDataParser.iequal = function (_ref39) {
  var _ref40 = built_in_slicedToArray(_ref39, 2),
      i1 = _ref40[0],
      i2 = _ref40[1];

  return i1 === i2;
};

builtInDataParser.iless = function (_ref41) {
  var _ref42 = built_in_slicedToArray(_ref41, 2),
      i1 = _ref42[0],
      i2 = _ref42[1];

  return Number(i1) < Number(i2);
};

builtInDataParser.igreater = function (_ref43) {
  var _ref44 = built_in_slicedToArray(_ref43, 2),
      i1 = _ref44[0],
      i2 = _ref44[1];

  return Number(i1) > Number(i2);
};

builtInDataParser.iless_equal = function (_ref45) {
  var _ref46 = built_in_slicedToArray(_ref45, 2),
      i1 = _ref46[0],
      i2 = _ref46[1];

  return Number(i1) <= Number(i2);
};

builtInDataParser.igreater_equal = function (_ref47) {
  var _ref48 = built_in_slicedToArray(_ref47, 2),
      i1 = _ref48[0],
      i2 = _ref48[1];

  return Number(i1) >= Number(i2);
};

builtInDataParser.add = built_in_calculateFilter(function (_ref49) {
  var _ref50 = built_in_slicedToArray(_ref49, 2),
      i1 = _ref50[0],
      i2 = _ref50[1];

  return Number(i1) + Number(i2);
});

builtInDataParser.sub = built_in_calculateFilter(function (_ref51) {
  var _ref52 = built_in_slicedToArray(_ref51, 2),
      i1 = _ref52[0],
      i2 = _ref52[1];

  return Number(i1) - Number(i2);
});

builtInDataParser.mul = built_in_calculateFilter(function (_ref53) {
  var _ref54 = built_in_slicedToArray(_ref53, 2),
      i1 = _ref54[0],
      i2 = _ref54[1];

  return Number(i1) * Number(i2);
});

builtInDataParser.div = built_in_calculateFilter(built_in_divisorZeroFilter(function (_ref55) {
  var _ref56 = built_in_slicedToArray(_ref55, 2),
      i1 = _ref56[0],
      i2 = _ref56[1];

  return Number(i1) / Number(i2);
}));

builtInDataParser.mod = built_in_calculateFilter(built_in_divisorZeroFilter(function (_ref57) {
  var _ref58 = built_in_slicedToArray(_ref57, 2),
      i1 = _ref58[0],
      i2 = _ref58[1];

  return Number(i1) % Number(i2);
}));

builtInDataParser.ceil = built_in_mathFilter(function (i1) {
  return Math.ceil(i1);
});

builtInDataParser.floor = built_in_mathFilter(function (i1) {
  return Math.floor(i1);
});

builtInDataParser.round = built_in_mathFilter(function (i1) {
  return Math.round(i1);
});

builtInDataParser.abs = built_in_mathFilter(function (i1) {
  return Math.abs(i1);
});

builtInDataParser.fequal = builtInDataParser.iequal;
builtInDataParser.fless = builtInDataParser.iless;
builtInDataParser.fgreater = builtInDataParser.igreater;
builtInDataParser.fless_equal = builtInDataParser.iless_equal;
builtInDataParser.fgreater_equal = builtInDataParser.igreater_equal;

/* ------------------------------------------------------------ */
/* 类型转换 */
builtInDataParser.toDouble = function (_ref59) {
  var _ref60 = built_in_slicedToArray(_ref59, 1),
      data = _ref60[0];

  return utils["toNumber"](data);
};

builtInDataParser.toLong = function (_ref61) {
  var _ref62 = built_in_slicedToArray(_ref61, 1),
      data = _ref62[0];

  return utils["toNumber"](data);
};

builtInDataParser.toStr = function (_ref63) {
  var _ref64 = built_in_slicedToArray(_ref63, 2),
      num1 = _ref64[0],
      num2 = _ref64[1];

  if (num1 && num2) {
    try {
      return utils["toNumber"](num1).toFixed(num2);
    } catch (e) {
      utils["log"].warn(e);
      return '';
    }
  } else {
    return num1 !== undefined ? String(num1) : '';
  }
};

/* ------------------------------------------------------------ */
/* 其他 */

builtInDataParser.const = function (_ref65) {
  var _ref66 = built_in_slicedToArray(_ref65, 1),
      data = _ref66[0];

  return data ? data.trim() : '';
};

builtInDataParser.len = function (_ref67) {
  var _ref68 = built_in_slicedToArray(_ref67, 1),
      data = _ref68[0];

  if (utils["isPlainObject"](data)) {
    return Object.keys(data).length;
  }

  return data ? ~~data.length : 0;
};

builtInDataParser.platform = function (_ref69) {
  var _ref70 = built_in_slicedToArray(_ref69, 1),
      data = _ref70[0];

  return data && data.toLowerCase() === 'h5';
};

builtInDataParser.eventChainEventData = function (_ref71, data, options) {
  var _ref72 = built_in_slicedToArray(_ref71, 1),
      _ref72$ = _ref72[0],
      stringKey = _ref72$ === undefined ? '' : _ref72$;

  if (!options.customParams) {
    return '';
  }
  return stringKey.split('.').reduce(function (value, key) {
    return value[key];
  }, options.customParams);
};

/* ------------------------------------------------------------ */
/* 渲染 */
builtInDataParser.linearGradient = function (_ref73) {
  var _ref74 = _toArray(_ref73),
      direction = _ref74[0],
      colors = _ref74.slice(1);

  var cssDirection = '';
  switch (direction) {
    case 'toLeft':
      cssDirection = 'to left';
      break;
    case 'toTop':
      cssDirection = 'to top';
      break;
    case 'toRight':
      cssDirection = 'to right';
      break;
    case 'toBottom':
      cssDirection = 'to bottom';
      break;
    default:
      break;
  }

  if (!cssDirection || !colors.length) {
    return null;
  }

  var linearGradient = 'linear-gradient(' + cssDirection + ',';
  colors.map(function (item, i) {
    var color = colorParser(item);
    var suffix = i === colors.length - 1 ? ')' : ',';

    linearGradient += color + suffix;
  });

  return linearGradient;
};

/* ------------------------------------------------------------ */
/* hack: 别名兼容，此处应该在编译环节解决掉 */
builtInDataParser.eq = builtInDataParser.equal;

builtInDataParser.aget = builtInDataParser.array_get;
builtInDataParser.afind = builtInDataParser.array_find;
builtInDataParser.dget = builtInDataParser.dict_get;

builtInDataParser.lc = builtInDataParser.lowercase;
builtInDataParser.uc = builtInDataParser.uppercase;

builtInDataParser.ieq = builtInDataParser.iequal;
builtInDataParser.ilt = builtInDataParser.iless;
builtInDataParser.igt = builtInDataParser.igreater;
builtInDataParser.ilte = builtInDataParser.iless_equal;
builtInDataParser.igte = builtInDataParser.igreater_equal;

builtInDataParser.feq = builtInDataParser.fequal;
builtInDataParser.flt = builtInDataParser.fless;
builtInDataParser.fgt = builtInDataParser.fgreater;
builtInDataParser.flte = builtInDataParser.fless_equal;
builtInDataParser.fgte = builtInDataParser.fgreater_equal;

builtInDataParser.less = builtInDataParser.iless;
builtInDataParser.greater = builtInDataParser.igreater;
builtInDataParser.lessEqual = builtInDataParser.iless_equal;
builtInDataParser.greaterEqula = builtInDataParser.igreater_equal;
builtInDataParser.greaterEqual = builtInDataParser.igreater_equal;

/* harmony default export */ var built_in = (builtInDataParser);
// CONCATENATED MODULE: ./src/data-parser/custom.js


var CUSTOM_DATA_PARSER = {};

var registerDataParser = function registerDataParser(name, customParser) {
  CUSTOM_DATA_PARSER[name] = customParser;
};

var custom_getDataParser = function getDataParser(name) {
  return CUSTOM_DATA_PARSER[name] || built_in[name];
};
// CONCATENATED MODULE: ./src/data-parser/index-v1.js
var index_v1_slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






var REG_PARSE_PATTERN = /\$(\w+)\{(.+?)\}/g;
var SEP_CHAR = ',';

var CACHED_DATA = Object(utils_cache["a" /* default */])('data');

/* ------------------------------------------------------------ */

/* harmony default export */ var index_v1 = (function (valueWithPattern, options) {
  var templateData = options.data || CACHED_DATA.get(options.tplId);
  var result = '';

  var matches = utils["matchRegexp"](valueWithPattern, REG_PARSE_PATTERN);

  if (Array.isArray(matches) && matches.length > 0) {
    matches.every(function (match) {
      var _match = index_v1_slicedToArray(match, 2),
          name = _match[0],
          expression = _match[1];

      var args = expression.split(SEP_CHAR);

      var parser = custom_getDataParser(name);
      if (parser) {
        result = parser.call(options.context, args, templateData, options);
      }

      return !result;
    });

    return result;
  }

  return valueWithPattern;
});
// CONCATENATED MODULE: ./src/data-parser/index-v2.js
var index_v2_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function index_v2_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







// 表达式识别标志
var FLAG_PATTERN_V2 = '@';

// 字符串常量识别标志
var FLAG_CONST_STR = '\'';

// 函数参数分隔符
var index_v2_SEP_CHAR = ',';

// 顺序表达式分隔符
var SEP_ORDER_PATTERN = ';';

var index_v2_CACHED_DATA = Object(utils_cache["a" /* default */])('data');
var CACHED_PARSER = Object(utils_cache["a" /* default */])('parser');

// 包含短路逻辑的白名单表达式
var SHORT_CIRCUIT_PATTERN = {
  'if': {
    conditionIndex: 0,
    conditionValue: true
  },
  'triple': {
    conditionIndex: 0,
    conditionValue: true,
    trueIndex: 1,
    falseIndex: 2
  },
  'or': {
    conditionIndex: -1,
    conditionValue: false
  },
  'and': {
    conditionIndex: -1,
    conditionValue: true
  }
};

/* ------------------------------------------------------------ */

var StringIterator = function () {
  function StringIterator(source) {
    index_v2_classCallCheck(this, StringIterator);

    this.source = source;
    this.maxLen = source.length;
    this.pos = -1;
  }

  index_v2_createClass(StringIterator, [{
    key: 'hasNext',
    value: function hasNext() {
      return this.pos < this.maxLen - 1;
    }
  }, {
    key: 'getPrevValue',
    value: function getPrevValue() {
      return this.source[this.pos - 1];
    }
  }, {
    key: 'getCurrentValue',
    value: function getCurrentValue() {
      return this.val;
    }
  }, {
    key: 'next',
    value: function next() {
      this.val = this.source[++this.pos];

      return {
        value: this.val,
        done: !this.hasNext()
      };
    }
  }, {
    key: 'loop',
    value: function loop(callback) {
      var walkChar = '';
      while (!this.next().done) {
        var result = callback(this.val, this.pos);

        if (!result) {
          break;
        }

        walkChar += this.val;
      }

      return walkChar;
    }
  }]);

  return StringIterator;
}();

/* ------------------------------------------------------------ */

function matchPattern(iterator) {
  var tmpPattern = {
    type: 'pattern'
  };

  // 1. 表达式名称解析
  tmpPattern.name = iterator.loop(function (char) {
    return char !== '{';
  });

  // 2. 表达式参数解析
  var args = [];
  iterator.loop(function () {
    var arg = matchArguments(iterator, index_v2_SEP_CHAR);

    if (utils["isPlainObject"](arg)) {
      args.push(arg);
    }

    if (iterator.getCurrentValue() === '}') {
      iterator.next();
      return false;
    }

    return true;
  });

  tmpPattern.args = args;

  return tmpPattern;
}

function matchArguments(iterator, sepChar) {
  var char = iterator.getCurrentValue();

  if (char === FLAG_PATTERN_V2) {
    return matchPattern(iterator);
  } else if (char === FLAG_CONST_STR) {
    return {
      type: 'const',
      content: iterator.loop(function (char) {
        return !(iterator.getPrevValue() !== '\\' && char === FLAG_CONST_STR);
      })
    };
  } else if (/[\w\d_\-\.]/.test(char)) {
    return {
      type: 'const',
      content: char + iterator.loop(function (char) {
        return char && !/[\s\}]/.test(char) && char !== sepChar;
      })
    };
  }
}

function parsePattern(pattern, templateData, options) {
  var name = pattern.name,
      type = pattern.type;

  if (type === 'const') {
    // 处理转义符：https://yuque.antfin.com/dinamicx/community/lgklw5
    var escapePattern = /\\(.)/g;
    if (escapePattern.test(pattern.content)) {
      pattern.content = pattern.content.replace(escapePattern, '$1');
    }
    return pattern.content;
  }

  if (type === 'pattern') {
    var parser = custom_getDataParser(name);

    if (parser) {
      var parsedArgs = processArgs(pattern, templateData, options);

      return parser.call(options.context, parsedArgs, templateData, options);
    } else {
      utils["log"].error('Can\'t find the given pattern [' + name + '], make sure you register it before use', {
        type: constant["c" /* ERROR_PARSER_404 */],
        templateName: options._tplName,
        parser: name
      });
    }
  }
}

function processArgs(pattern, templateData, options) {
  var parsedArgs = [];
  var shortCircuit = SHORT_CIRCUIT_PATTERN[pattern.name];

  // 短路逻辑，不必解析所有参数，尤其事件场景
  if (shortCircuit) {
    pattern.args.map(function (arg, index) {
      // 默认全部解析，针对短路配置，剔除不解析的参数
      var shouldParse = true;
      // 首位参数直接解析
      if (index > 0) {
        var conditionArgIndex = shortCircuit.conditionIndex === -1 ? index - 1 : shortCircuit.conditionIndex;
        if (toLikeBoolean(parsedArgs[conditionArgIndex]) === shortCircuit.conditionValue) {
          // 有 trueIndex，并且 trueIndex 不为当前 index，不解析
          if (shortCircuit.hasOwnProperty('trueIndex') && shortCircuit.trueIndex !== index) {
            shouldParse = false;
          }
        } else {
          // 无 falseIndex，或 falseIndex 不为当前 index，不解析（三目表达式场景）
          if (!shortCircuit.hasOwnProperty('falseIndex') || shortCircuit.falseIndex !== index) {
            shouldParse = false;
          }
        }
      }

      if (shouldParse) {
        parsedArgs.push(parsePattern(arg, templateData, options));
      } else {
        parsedArgs.push(null);
      }
    });
  } else {
    // 无短路逻辑的 parser，直接解析所有参数
    parsedArgs = pattern.args.map(function (arg) {
      return parsePattern(arg, templateData, options);
    });
  }

  return parsedArgs;
}

/* ------------------------------------------------------------ */
/* harmony default export */ var index_v2 = (function (valueWithPattern, options) {
  var tplId = options._tplId;
  var tplName = options._tplName;
  var patterns = CACHED_PARSER.get(tplName + valueWithPattern);
  var data = index_v2_CACHED_DATA.get(tplId) || options.data;

  // 优先走缓存，如果没有缓存，则重新解析ast
  if (!patterns) {
    patterns = [];

    var iterator = new StringIterator(valueWithPattern);

    /* ------------------------------------------------------------ */
    /* 词法分析 */

    // 最外层识别
    // 支持 ; 分割的顺序多个表达式
    try {
      iterator.loop(function () {
        var pattern = matchArguments(iterator, SEP_ORDER_PATTERN);

        if (utils["isPlainObject"](pattern)) {
          patterns.push(pattern);
        }

        return true;
      });
    } catch (e) {
      utils["log"].error(e, {
        type: constant["a" /* ERROR_DATA_PARSER_GEN_AST */],
        templateId: tplId,
        parser: valueWithPattern
      });
    }

    CACHED_PARSER.set(tplName + valueWithPattern, patterns);
  }

  /* ------------------------------------------------------------ */
  /* 表达式解析 */

  var result = void 0;
  try {
    patterns.some(function (token) {
      result = parsePattern(token, data, options);

      return result;
    });
  } catch (e) {
    utils["log"].error(e, {
      type: constant["b" /* ERROR_DATA_PARSER_PARSE */],
      templateName: tplName,
      parser: valueWithPattern
    });
  }

  return result;
});
// CONCATENATED MODULE: ./src/event-handler.js
var event_handler_slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function event_handler_toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * DinamicX 事件处理
 * 
 * @module EventHandler
 */






var CACHED_HANDLER = Object(utils_cache["a" /* default */])('handler');

/* ------------------------------------------------------------ */

var builtInEvent = {
  _openUrl: function _openUrl(_ref) {
    var _ref2 = event_handler_slicedToArray(_ref, 1),
        url = _ref2[0];

    // 发送全局事件，通知页面已经跳转
    window.dispatchEvent(new Event('page:jump'));

    window.location.href = url;
  }
};

/* ------------------------------------------------------------ */

/**
 * 获取已注册的 DinamicX 事件
 * @param {string} name - 事件名称
 */
function getEventHandler(name) {
  return CACHED_HANDLER.get(name);
}

/**
 * @callback DinamicXEventHandler
 * @param {string[]} args - DinamicX 模版显式传递的参数
 * @param {Object} data - 当前模版数据
 * @param {Object} options - 配置信息，主要包含 tplId
 * @param {string} options.tplId - 当前模版ID
 * @param {Object} options.context - 当前绑定事件的控件的上下文
 * @param {Event} options.event - 原始事件对象
 */

/**
 * 注册 DinamicX 事件
 * 
 * @param {string} name - 事件名称
 * @param {DinamicXEventHandler} handler - 事件回调函数
 */
function registerEventHandler(name, handler) {
  // v1 不需要返回值，支持多个 handler
  var registeredHandler = getEventHandler(name);
  var newHandler = handler;
  if (registeredHandler) {
    if (Array.isArray(registeredHandler)) {
      newHandler = [].concat(event_handler_toConsumableArray(registeredHandler), [handler]);
    } else {
      newHandler = [registeredHandler, handler];
    }
  }

  CACHED_HANDLER.set(name, newHandler);

  // 表达式2.0版本，事件与表达式统一
  registerDataParser(name, handler);
}

/* ------------------------------------------------------------ */

// 绑定内置事件
setTimeout(function () {
  Object(utils["mapValue"])(builtInEvent, function (handler, key) {
    return registerEventHandler(key, handler);
  });
}, 0);
// CONCATENATED MODULE: ./src/parser.js
var parser_slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * 表达式管理
 *
 * @module Parser
 */











// 匹配事件回调函数名称和参数
var REG_EVENT_HANDLER = /^([a-zA-Z]\w*?)\s*\((.*?)\)$/;

// 匹配单位名称和值
var REG_PARSE_UNIT = /^([\-\d\.]+)(np|ap)?$/g;

// 匹配颜色
var REG_PARSE_COLOR = /^#(?:\w{4}|\w{8})$/;

var parser_CACHED_DATA = Object(utils_cache["a" /* default */])('data');

/* ------------------------------------------------------------ */
/* Data Parser */



/**
 * 表达式解析
 * @param {string} pattern - 表达式字符串
 * @param {Object} options - 额外参数
 * @param {string} options._tplId - 模版id
 * @param {string} [options.data] - 模版数据
 */
var parser_dataParser = function dataParser(pattern, options) {
  if (pattern) {
    var firstLetter = pattern[0];

    switch (firstLetter) {
      case '@':
        return index_v2(pattern, options);
      case '$':
        return index_v1(pattern, options);
    }
  }

  return pattern;
};

/* ------------------------------------------------------------ */
/* Other Parser */

/**
 * 事件表达式解析
 * @param {string} handlerInString - 事件表达式字符串
 * @param {Object} options - 额外参数
 * @param {string} options._tplId - 模版id
 * @returns {Function} 事件回调函数
 */
var parser_eventHandlerParser = function eventHandlerParser(handlerInString, options) {
  var parserVersion = handlerInString && handlerInString[0] === '@' ? 'v2' : 'v1';
  var data = parser_CACHED_DATA.get(options._tplId);

  return {
    pattern: handlerInString,
    options: options,
    handler: function handler(eventObj, customParams) {
      options.event = eventObj;
      // 事件传入参数被注解 @eventChainEventData 读取，见 https://yuque.antfin-inc.com/dinamicx/document/oaxwpl
      options.customParams = customParams;

      if (parserVersion === 'v1') {
        var match = utils["matchRegexp"](handlerInString, REG_EVENT_HANDLER);
        if (match) {
          var _match = parser_slicedToArray(match, 2),
              name = _match[0],
              argsString = _match[1];

          var handler = getEventHandler(name);

          if (handler) {
            var args = utils["compactArray"](utils["trimAllBlankString"](argsString).split(',').map(function (arg) {
              return parser_dataParser(arg, options);
            }));

            if (Array.isArray(handler)) {
              handler.map(function (item) {
                item.call(null, args, data, options);
              });
            } else {
              // 应该不需要 return，先留着
              return handler.call(null, args, data, options);
            }
          } else {
            utils["log"].error('Can\'t find the given event handler [' + name + '], make sure you register it before use', {
              type: constant["c" /* ERROR_PARSER_404 */],
              templateName: options._tplName
            });
          }
        }
      } else if (parserVersion === 'v2') {
        return parser_dataParser(handlerInString, options);
      }
    }
  };
};

/* ------------------------------------------------------------ */

// hack: #AARRGGBB, #ARGB
/**
 * Native 4位或8位带透明度的HEX色值解析
 * @param {string} colorWithAlpha - 带透明度的8位HEX色值
 * @returns {string} css rgba形式
 */
var colorParser = function colorParser(colorWithAlpha) {
  if (REG_PARSE_COLOR.test(colorWithAlpha)) {
    var result = [];
    var coef = colorWithAlpha.length === 9 ? 2 : 1;

    for (var i = 1; i < colorWithAlpha.length; i += coef) {
      var tempNum = ~~('0x' + colorWithAlpha.slice(i, i + coef));

      result.push(16 * tempNum * (2 / coef - 1) + tempNum);
    }

    // move Alpha to the end
    result.push(result.shift() / 255);

    return 'rgba(' + result.join() + ')';
  }

  return colorWithAlpha;
};

/**
 * Native ap/np 单位解析
 * @param {string} numberWithUnit - 带单位的数字
 * @returns {string} 以px为单位的数字
 */
var parser_unitParser = function unitParser(numberWithUnit) {
  var _utils$env = utils["env"],
      deviceWidth = _utils$env.deviceWidth,
      devicePixelRatio = _utils$env.devicePixelRatio,
      isIOS = _utils$env.isIOS;

  // 数字会默认为 ap 的单位

  if (!isNaN(numberWithUnit)) {
    numberWithUnit += 'ap';
  }

  if (typeof numberWithUnit === 'string') {
    return numberWithUnit.replace(REG_PARSE_UNIT, function (match, number, unit) {
      number = Number(number);

      if (number > 0) {
        switch (unit) {
          case 'np':
            break;
          case 'ap':
          default:

            // ap = number / 375 * ScreenWidth
            number = number / 375 * deviceWidth;
        }

        // 兼容支持 0.5px 细线
        if (number < 1) {
          number = number > 0.5 || devicePixelRatio === 1 || !isIOS ? 1 : 0.5;
        } else {
          number = utils["numTrunc"](number);
        }
      }

      return number + 'px';
    });
  }

  return numberWithUnit || 0;
};
// CONCATENATED MODULE: ./src/view-helper.js
var GRID_TAG_MAP = {
  FrameLayout: 'FrameLayoutNG',
  DFrameLayout: 'FrameLayoutNG'
};
function replaceTagNameForLayoutNG(tagName) {
  return GRID_TAG_MAP[tagName] || tagName;
}
// CONCATENATED MODULE: ./src/view.js
var view_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var view_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var view_slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function view_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 渲染管理
 *
 * @module View
 */













var view_CACHED_DATA = Object(utils_cache["a" /* default */])('data');
var CACHED_VIEW = Object(utils_cache["a" /* default */])('view');

var TPL_WRAPPER_KEY = 'data-tpl-id';

var view_getDefaultTemplateId = function getDefaultTemplateId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return utils["getUniqueId"](data.templateName || utils["deepGet"](data, 'template.name') || 'dt');
};

var TEMPLATE_PLUGIN_LIST = [];

// 匹配带前缀的属性，暂时仅去掉 “d” 前缀
var REG_PROP_WITH_PREFIEX = /^[d][A-Z]/;

// 匹配带前缀的控件，双大写开头认为是带前缀控件名，2个以上大写字母开头忽略
var REG_VIEWNAME_WITH_PREFIEX = /^[A-Z]{2}[0-9a-z_\-]/;

// hack：获取 prop setter，兼容 < 3.0.0 模版版本，会尝试去掉前缀
function removePropPrefix(key) {
  var tempKey = key.slice(1);
  key = tempKey[0].toLowerCase() + tempKey.slice(1);

  return key;
};
function removeViewNamePrefix(name) {
  if (REG_VIEWNAME_WITH_PREFIEX.test(name)) {
    return name.slice(1);
  }
  return name;
};

function processAndCacheData(templateId, data) {
  // hack: 兼容数组包裹的对象
  if (Array.isArray(data)) {
    data = data[0] || {};
  }

  view_CACHED_DATA.set(templateId, data);

  return data;
}

/* ------------------------------------------------------------ */

/**
 * 获取已注册的 DinamicX 控件
 * @param {string} name - 控件名称
 */
function getView(name) {
  return CACHED_VIEW.get(name);
}

/**
 * 注册 DinamicX 控件
 * @param {string} name - 控件名称
 * @param {View} View - 控件实现类
 */
function registerView(name, View) {
  CACHED_VIEW.set(name, View);
}

function createIndexMap() {
  if (Object(config["a" /* getGlobalConfig */])('enableForceUpdate')) {
    // TODO: listlayout 等情况更新数据情况节点重用 bug
    this.componentIdSeq = this.componentIdSeq || 0;
  } else {
    // 缓存自增序列 componentId，用于唯一确定component
    this.componentIdSeq = 0;
  }

  // 模版控件索引有序列表（自顶向下）
  this.componentIndexSet = [];
}

function processParser(attrs, options) {
  var _this = this;

  if (utils["isPlainObject"](attrs)) {
    var parsedAttrs = {};
    utils["mapValue"](attrs, function (val, key) {

      // 目前采用特殊属性 h5RavelBind的方式作为ravel联动的绑定标识
      if (key === 'h5RavelBind') {
        var _val$split = val.split('|'),
            _val$split2 = view_slicedToArray(_val$split, 2),
            bindKey = _val$split2[0],
            target = _val$split2[1];

        // 绑定组件联动


        ravel.bind(_this, options._tplId, _defineProperty({}, bindKey, target));
      }

      // parser和事件处理逻辑
      // 兼容 switch 组件不规范的属性名定义
      if (key.slice(0, 2) === 'on' && key !== 'onColor') {
        parsedAttrs[key] = parser_eventHandlerParser(val, options);
      } else {
        var tempKey = key;

        // 去掉 d开头前缀
        if (REG_PROP_WITH_PREFIEX.test(key)) {
          tempKey = removePropPrefix(key);
        }

        parsedAttrs[tempKey] = parser_dataParser(val, options);
      }
    });

    return parsedAttrs;
  }

  return {};
}

/**
 * 通过 Url 创建 DinamicX View，提供自动模版链接聚合请求以及缓存功能
 * @inner
 * @param {JSON} tplNodeTree 模版对应的节点树. 通过 `@ali/dinamic-template` 组件导出
 * @param {JSON} data 模版数据
 * @param {Object} options  - 模版属性信息
 * @param {Object} options._tplId   - 模版id
 * @param {Object} options._context - 模版上下文
 * @param {Object} children 组件的子元素
 */
function createViews(tplNodeTree) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _this2 = this;

  var options = arguments[2];
  var children = arguments[3];

  var templateId = options._tplId;

  // hack: 后续编译器会加入 complier version 来确定编译器版本
  var complierVersion = tplNodeTree.bizCode && tplNodeTree.template ? '3.0.0' : '0.0.0';

  // 3.0.0 是一个break版本，修改了 JS 模版文件的格式
  var isBreakingVersion = utils["compareComplierVersion"](complierVersion, '3.0.0') >= 0;

  var createVNodes = function createVNodes(nodeTree, parentOptions) {
    return nodeTree.map(function () {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // 不能直接修改 tag.name，会影响模版本地缓存
      var currentTagName = tag.name;
      if (_this2._enableLayoutNG) {
        currentTagName = replaceTagNameForLayoutNG(currentTagName);
      }

      var tempView = getView(currentTagName);

      if (currentTagName === 'Children' && children) {
        return children;
      }

      // TODO: 先做隐藏处理 https://yuque.antfin.com/dinamicx/qzvpry/iwgxxt
      if (tag.attrs && tag.attrs.userId && parentOptions && parentOptions._originProps && String(parentOptions._originProps.alwaysShowIndicator) !== 'true' && parentOptions._originProps.moreIndicatorUserId === tag.attrs.userId) {
        return null;
      }

      if (tempView) {
        var _id = templateId + '_c' + ++_this2.componentIdSeq;

        var spOptions = {
          key: _id,
          _id: _id,
          // id 在 sequence 中的 index
          _idIndex: _this2.componentIdSeq - 1,
          _tplId: templateId,
          _tplName: options._tplName,
          _tplContext: options._context,
          _viewName: removeViewNamePrefix(currentTagName),
          _originProps: tag.attrs
        };

        var parsedAttrs = view_extends({}, processParser.call(_this2, tag.attrs, view_extends({
          data: data
        }, spOptions)), spOptions, {
          childrenLen: Array.isArray(tag.children) ? tag.children.length : 0,
          templateContent: tag.templateContent
        });

        // layout有序列表缓存
        _this2.componentIndexSet.push({
          id: _id,
          props: parsedAttrs,
          pid: parentOptions ? parentOptions._id : null
        });

        return Object(external_amd_react_commonjs_react_commonjs2_react_root_React_["createElement"])(tempView, parsedAttrs, tag.children && createVNodes(tag.children, spOptions));
      } else {
        utils["log"].error(new Error('View not found ' + currentTagName), {
          type: constant["l" /* ERROR_VIEW_404 */],
          viewName: currentTagName,
          templateName: options._tplName
        });
      }
    });
  };

  // 组件递归创建 vdom实例
  return createVNodes(isBreakingVersion ? tplNodeTree.template : tplNodeTree);
}

/**
 * 取模版的默认高度，延迟渲染 placeholder 使用
 */
function getTplDefaultHeight(views) {
  var rootElement = Array.isArray(views) ? views[0] : views;
  var defaultHeight = '300px';

  if (rootElement && rootElement.attrs && rootElement.attrs.defaultHeight) {
    defaultHeight = parser_unitParser(rootElement.attrs.defaultHeight) || defaultHeight;
  }

  return defaultHeight;
}

/**
 * Template Class
 * 封装模版请求和渲染过程
 * 提供生命周期函数使得整体过程外部可控
 * 提供插件机制，使得外部可以对所有模版做通用控制
 *
 * @class Template
 * @property {Object} url - 模版Url
 * @property {JSON} tpl - 模版对应的节点树. 通过 '@ali/dinamic-template' 组件导出
 * @property {JSON} data - 模版数据
 * @property {string} className
 * @property {Object} style
 * @property {Object} extraAttrs
 * @property {function} componentWillBindEvent - 【控件】生命周期回调，绑定事件前触发
 * @property {function} componentFinishFirstPaint - 【控件】生命周期回调，控件首次渲染完成，可以拿到控件属性userId、dom element以及模版信息
 * @property {function} templateWillDownload - 【模版】生命周期回调，下载前触发
 * @property {function} templateFinishDownload - 【模版】生命周期回调，下载完成触发
 * @property {function} templateDownloadError - 【模版】生命周期回调，下载失败触发
 * @property {function} templateWillRender - 【模版】生命周期回调，渲染前触发
 * @property {function} templateFinishFirstPaint - 【模版】生命周期回调，首次渲染完成触发
 * @property {function} templateFinishUpdate - 【模版】生命周期回调，更新完成触发（2 - n次重渲染完成）
 * @property {string} [templateName] - 模版名称（如果传入url，会自动解析，如果是写死的模版，则推荐自行传入）
 * @property {string} [customTemplateId] - 特殊模版id
 * @example
 * import * as Dinamic from '@ali/dinamic';
 * import '@ali/dinamic-views';
 *
 * const url = xx;
 * const data = xx;
 *
 * const {Template, Fragment} = Dinamic;
 *
 * Dinamic.render((
 *   <Fragment>
 *     <Template url={url} data={data}></Template>
 *     <Template url={url} data={data}></Template>
 *   </Fragment>
 * ), document.querySelector('#app'));
 *
 */
var view_Template = function (_Component) {
  _inherits(Template, _Component);

  function Template(props) {
    view_classCallCheck(this, Template);

    var _this3 = _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).call(this, props));

    _this3.initPerfTracker();

    // update 的情况不再做 lazyrender
    _this3._enableLazyload = Object(config["a" /* getGlobalConfig */])('enableLazyload');

    _this3._enableLayoutNG = Object(config["a" /* getGlobalConfig */])('enableLayoutNG');

    _this3.initByProps(props);
    return _this3;
  }

  view_createClass(Template, [{
    key: 'initPerfTracker',
    value: function initPerfTracker() {
      this.perfTrackerPerfix = perf_tracker_init();
      mark(this.perfTrackerPerfix, TPL_INIT);
    }
  }, {
    key: 'initByProps',
    value: function initByProps() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = props.url,
          tpl = props.tpl,
          data = props.data,
          templateName = props.templateName,
          customTemplateId = props.customTemplateId;

      // 解析模版 Url

      var tplInfo = {};
      if (url) {
        tplInfo = downloader.processTplUrl(url) || {};
      }

      // 获取业务设置的模板缓存
      var tplCache = Object(config["b" /* getTplCache */])(url);
      // 生成templateId
      var templateId = customTemplateId || view_getDefaultTemplateId(data);

      // 缓存模版数据
      data = processAndCacheData(templateId, data);

      // 内部虚拟 state
      this.shadow = {
        // 兼容详情带 content 的结构
        tpl: tpl || tplCache && tplCache.content || tplCache || downloader.getCache(tplInfo, this.perfTrackerPerfix),
        data: data,
        options: {
          _context: this,
          _tplId: templateId,

          // 如果模版名称未取到，则兜底使用id作为name
          _tplName: templateName || tplInfo.name || templateId
        }
      };

      // 绑定生命周期函数
      this.bindLifeCycleEvent();
    }
  }, {
    key: 'bindLifeCycleEvent',
    value: function bindLifeCycleEvent() {
      var noop = function noop() {};
      var _props = this.props,
          _props$componentWillB = _props.componentWillBindEvent,
          componentWillBindEvent = _props$componentWillB === undefined ? noop : _props$componentWillB,
          _props$componentFinis = _props.componentFinishFirstPaint,
          componentFinishFirstPaint = _props$componentFinis === undefined ? noop : _props$componentFinis,
          _props$templateWillDo = _props.templateWillDownload,
          templateWillDownload = _props$templateWillDo === undefined ? noop : _props$templateWillDo,
          _props$templateFinish = _props.templateFinishDownload,
          templateFinishDownload = _props$templateFinish === undefined ? noop : _props$templateFinish,
          _props$templateDownlo = _props.templateDownloadError,
          templateDownloadError = _props$templateDownlo === undefined ? noop : _props$templateDownlo,
          _props$templateWillRe = _props.templateWillRender,
          templateWillRender = _props$templateWillRe === undefined ? noop : _props$templateWillRe,
          _props$templateFinish2 = _props.templateFinishCreateViews,
          templateFinishCreateViews = _props$templateFinish2 === undefined ? noop : _props$templateFinish2,
          _props$templateFinish3 = _props.templateFinishFirstPaint,
          templateFinishFirstPaint = _props$templateFinish3 === undefined ? noop : _props$templateFinish3,
          _props$templateFinish4 = _props.templateFinishUpdate,
          templateFinishUpdate = _props$templateFinish4 === undefined ? noop : _props$templateFinish4;


      var instanceLifeCycles = {
        componentWillBindEvent: componentWillBindEvent,
        componentFinishFirstPaint: componentFinishFirstPaint,
        templateWillDownload: templateWillDownload,
        templateFinishDownload: templateFinishDownload,
        templateDownloadError: templateDownloadError,
        templateWillRender: templateWillRender,
        templateFinishCreateViews: templateFinishCreateViews,
        templateFinishFirstPaint: templateFinishFirstPaint,
        templateFinishUpdate: templateFinishUpdate
      };

      this.lifeCycles = utils["mapValue"](instanceLifeCycles, function (event, name) {
        return function () {
          var _this4 = this;

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          // 优先执行plugin
          TEMPLATE_PLUGIN_LIST.forEach(function (plugin) {
            var pluginLifeCycleEvent = plugin[name];

            if (pluginLifeCycleEvent) {
              pluginLifeCycleEvent.apply(_this4, args);
            }
          });

          return event.apply(this, args);
        };
      });
    }
  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch(e) {
      var _tplName = this.shadow.options._tplName;


      utils["log"].error(e, {
        type: constant["j" /* ERROR_TEMPLATE_RENDER */],
        templateName: _tplName
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _lifeCycles = this.lifeCycles,
          templateFinishFirstPaint = _lifeCycles.templateFinishFirstPaint,
          templateFinishUpdate = _lifeCycles.templateFinishUpdate;

      // 无标识位，认为是首次渲染

      if (this.shadow.tpl) {
        if (!this.firstPaint) {

          // hook
          templateFinishFirstPaint.call(this, this.shadow);
          this.firstPaint = true;
        } else {

          // hook
          templateFinishUpdate.call(this, this.shadow);
        }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      mark(this.perfTrackerPerfix, TPL_DID_MOUNT);

      var templateFinishFirstPaint = this.lifeCycles.templateFinishFirstPaint;


      if (!this.shadow.tpl) {

        // 初始化模版下载
        this.rerenderTemplateByUrl(this.props.url);
      } else {

        // hook
        templateFinishFirstPaint.call(this, this.shadow);
        this.firstPaint = true;
      }

      if (this._enableLazyload) {
        this.connectLazyObserver();
      }
    }
  }, {
    key: 'connectLazyObserver',
    value: function connectLazyObserver() {
      var _this5 = this;

      var options = this.shadow.options;

      var templateId = options._tplId;
      if (!templateId) {
        utils["log"].warn('Cannot get template id');
        return;
      }

      var intersectionObserver = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) {
          return entry.intersectionRatio > 0;
        })) {
          // console.log(templateId, entries)
          _this5._enableLazyload = false;
          _this5.forceUpdate();
          intersectionObserver.disconnect();
        }
      });
      intersectionObserver.observe(document.querySelector('div[' + TPL_WRAPPER_KEY + '="' + templateId + '"]'));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var nextData = nextProps.data,
          nextUrl = nextProps.url,
          nextTpl = nextProps.tpl;
      var _props2 = this.props,
          data = _props2.data,
          url = _props2.url,
          tpl = _props2.tpl;

      var needUpdate = false;

      if (url !== nextUrl) {
        this.rerenderTemplateByUrl(nextUrl, true);
        needUpdate = true;
      }

      if (nextData !== data) {
        this.rerenderTemplateByData(nextData);
        needUpdate = true;
      }

      if (nextTpl && JSON.stringify(nextTpl) !== JSON.stringify(tpl)) {
        this.initByProps(nextProps);
        needUpdate = true;
      }

      return needUpdate;
    }
  }, {
    key: 'rerenderTemplateByData',
    value: function rerenderTemplateByData(data) {

      // 处理并缓存模版数据
      data = processAndCacheData(this.shadow.options._tplId, data);

      this.shadow.data = data;
    }
  }, {
    key: 'rerenderTemplateByUrl',
    value: function rerenderTemplateByUrl(url, forceDownload) {
      var _this6 = this;

      var _shadow = this.shadow,
          tpl = _shadow.tpl,
          data = _shadow.data,
          options = _shadow.options;


      if (url && (!tpl || forceDownload)) {
        var _lifeCycles2 = this.lifeCycles,
            templateWillDownload = _lifeCycles2.templateWillDownload,
            templateFinishDownload = _lifeCycles2.templateFinishDownload,
            templateDownloadError = _lifeCycles2.templateDownloadError;

        // hook

        templateWillDownload.call(this, this.shadow);

        downloader.add(url, this.perfTrackerPerfix).then(function (_ref) {
          var tpl = _ref.tplNodeTree,
              template = _ref.template;


          // 缓存 template 信息到 options 内
          options._template = template;

          // hook
          templateFinishDownload.call(_this6, _this6.shadow);

          if (tpl) {
            _this6.shadow.tpl = tpl;

            // 复制到state 可能会引发bug，所以复制到私有变量
            _this6.forceUpdate();
          }
        }).catch(function (e) {
          templateDownloadError(e);
        });
      }
    }
  }, {
    key: 'renderTemplateWrapper',
    value: function renderTemplateWrapper(views) {
      var _tplWrapperProps;

      var _props3 = this.props,
          style = _props3.style,
          className = _props3.className,
          extraAttrs = _props3.extraAttrs;
      var _shadow2 = this.shadow,
          options = _shadow2.options,
          tpl = _shadow2.tpl;

      var templateId = options._tplId;
      var defaultHeight = getTplDefaultHeight(tpl);

      /* ------------------------------------------------------------ */
      /* 创建模版节点 */

      var tplWrapperProps = (_tplWrapperProps = {
        'data-spm': templateId
      }, _defineProperty(_tplWrapperProps, TPL_WRAPPER_KEY, templateId), _defineProperty(_tplWrapperProps, 'className', 'tpl-wrapper'), _tplWrapperProps);
      if (this._enableLazyload) {
        if (this.props.placeholder && typeof this.props.placeholder === 'function') {
          views = Object(external_amd_react_commonjs_react_commonjs2_react_root_React_["createElement"])(this.props.placeholder, {
            defaultHeight: defaultHeight,
            tpl: tpl,
            data: this.props.data
          });
        } else {
          tplWrapperProps.style = {
            height: defaultHeight
          };
        }
      }

      if (className) {
        tplWrapperProps.className += ' ' + className;
      }

      if (utils["isPlainObject"](style)) {
        tplWrapperProps.style = style;
      }

      if (utils["isPlainObject"](extraAttrs)) {
        Object.assign(tplWrapperProps, extraAttrs);
      }

      if (Object(config["a" /* getGlobalConfig */])('autotestMode')) {
        tplWrapperProps['aria-label'] = templateId;
      }

      return Object(external_amd_react_commonjs_react_commonjs2_react_root_React_["createElement"])('div', tplWrapperProps, views);
    }
  }, {
    key: 'renderViews',
    value: function renderViews(tpl) {
      var _shadow3 = this.shadow,
          data = _shadow3.data,
          options = _shadow3.options;
      var children = this.props.children;


      if (tpl) {

        // 创建控件索引表
        createIndexMap.call(this);

        mark(this.perfTrackerPerfix, BEFORE_CREATE_VDOM);
        var views = createViews.call(this, tpl, data, options, children);
        mark(this.perfTrackerPerfix, AFTER_CREATE_VDOM);

        return views;
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var tpl = this.shadow.tpl;
      var _lifeCycles3 = this.lifeCycles,
          templateWillRender = _lifeCycles3.templateWillRender,
          templateFinishCreateViews = _lifeCycles3.templateFinishCreateViews;

      // hook

      templateWillRender.call(this, this.shadow);

      // 构造views
      var views = this._enableLazyload ? null : this.renderViews(tpl);

      // 构造tpl的容器，即使没有views也会渲染出空容器
      var vdom = this.renderTemplateWrapper(views);

      // hook
      templateFinishCreateViews.call(this, this.shadow);

      return vdom;
    }
  }]);

  return Template;
}(external_amd_react_commonjs_react_commonjs2_react_root_React_["Component"]);

/**
 * @typedef Plugin
 * @type {Object}
 * @property {function} componentWillBindEvent - 【控件】生命周期回调，绑定事件前触发
 * @property {function} componentFinishFirstPaint - 【控件】生命周期回调，控件首次渲染完成，可以拿到控件属性userId和dom element
 * @property {function} templateWillDownload - 【模版】生命周期回调，下载前触发
 * @property {function} templateFinishDownload - 【模版】生命周期回调，下载完成触发
 * @property {function} templateDownloadError - 【模版】生命周期回调，下载失败触发
 * @property {function} templateWillRender - 【模版】生命周期回调，渲染前触发
 * @property {function} templateFinishFirstPaint - 【模版】生命周期回调，首次渲染完成触发
 * @property {function} templateFinishUpdate - 【模版】生命周期回调，更新完成触发（2 - n次重渲染完成）
 */

/**
 * 增加模版插件
 *
 * @param {Plugin[]} list - 插件列表
 */
function addTemplatePlugins(list) {
  if (Array.isArray(list)) {
    list.forEach(function (plugin) {
      if (utils["isPlainObject"](plugin)) {
        TEMPLATE_PLUGIN_LIST.push(plugin);
      }
    });
  }
}

/**
 * 设置设备宽度，用于非全屏渲染
 * 默认会同时设定模版最大宽度CSS样式，可以在业务内通过样式覆盖掉
 *
 * @param {Number} width - 设备宽度
 */
function setDeviceWidth(width) {
  var env = utils["env"];

  // 重设 device width
  env.deviceWidth = width;

  var $style = document.createElement('style');
  $style.innerHTML = '.tpl-wrapper{max-width: ' + width + 'px}';
  document.head.appendChild($style);
}

/**
 * 空组件，用于做为jsx外层包裹
 * 同 React.Fragment，preact无法使用
 * @class
 */
function Fragment(props) {
  return props.children;
}
// CONCATENATED MODULE: ./src/local-image.js
/**
 * 本地图片缓存管理
 * 
 * @module LocalImage
 */




var CACHED_LOCAL_IMAGE = Object(utils_cache["a" /* default */])('local-image');

/**
 * 获取已设置的本地缓存图片
 * @param {string} name - 图片名称
 */
function getLocalImage(name) {
  return CACHED_LOCAL_IMAGE.get(name);
}

/**
 * 设置一组本地缓存图片，可以支持url或者base64等格式
 * @param {Object.<string, string>} imageMap - 图片集合
 */
function setLocalImage(imageMap) {
  Object(utils["mapValue"])(imageMap, function (img, name) {
    CACHED_LOCAL_IMAGE.set(name, img);
  });
}
// EXTERNAL MODULE: external {"amd":"react-dom","commonjs":"react-dom","commonjs2":"react-dom","root":"ReactDOM"}
var external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_ = __webpack_require__(7);

// CONCATENATED MODULE: ./src/framework-adaptor.js
var framework_adaptor_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var driver = {
  findDOMNode: external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_["findDOMNode"],
  cloneElement: external_amd_react_commonjs_react_commonjs2_react_root_React_["cloneElement"],
  renderDriver: null
};

var setDriver = function setDriver() {
  var newDriver = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  try {
    driver = framework_adaptor_extends({}, driver, newDriver);
  } catch (e) {
    throw e;
  }
};

/**
 * 兼容 rax1.x
 */
var render = function name(element, container, options, callback) {
  if (driver.renderDriver) {
    if (options) {
      options.driver = driver.renderDriver;
    } else {
      options = {
        driver: driver.renderDriver
      };
    }

    external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_["render"](element, container, options, callback);
  } else {
    external_amd_react_dom_commonjs_react_dom_commonjs2_react_dom_root_ReactDOM_["render"].apply(this, arguments);
  }
};


// CONCATENATED MODULE: ./index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return external_amd_react_commonjs_react_commonjs2_react_root_React_["createElement"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Component", function() { return external_amd_react_commonjs_react_commonjs2_react_root_React_["Component"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "driver", function() { return driver; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setDriver", function() { return setDriver; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getView", function() { return getView; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "registerView", function() { return registerView; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Template", function() { return view_Template; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "addTemplatePlugins", function() { return addTemplatePlugins; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Fragment", function() { return Fragment; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getDataParser", function() { return custom_getDataParser; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "registerDataParser", function() { return registerDataParser; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "dataParser", function() { return parser_dataParser; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "colorParser", function() { return colorParser; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unitParser", function() { return parser_unitParser; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "eventHandlerParser", function() { return parser_eventHandlerParser; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getLocalImage", function() { return getLocalImage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setLocalImage", function() { return setLocalImage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getEventHandler", function() { return getEventHandler; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "registerEventHandler", function() { return registerEventHandler; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setDeviceWidth", function() { return setDeviceWidth; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Downloader", function() { return downloader; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "initIndexedDB", function() { return downloader_initIndexedDB; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "initLocalStorage", function() { return initLocalStorage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "STORAGE_TEMPLATE", function() { return STORAGE_TEMPLATE; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "tracker", function() { return tracker["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "perfTracker", function() { return perf_tracker_namespaceObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Ravel", function() { return ravel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setGlobalConfig", function() { return config["c" /* setGlobalConfig */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getGlobalConfig", function() { return config["a" /* getGlobalConfig */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setTplCache", function() { return config["d" /* setTplCache */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getTplCache", function() { return config["b" /* getTplCache */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "utils", function() { return utils; });














// 统一出口
/* harmony default export */ var index_0 = __webpack_exports__["default"] = ({
  h: external_amd_react_commonjs_react_commonjs2_react_root_React_["createElement"],
  render: render,
  Component: external_amd_react_commonjs_react_commonjs2_react_root_React_["Component"],
  driver: driver,
  setDriver: setDriver,

  getView: getView,
  registerView: registerView,
  Template: view_Template,
  addTemplatePlugins: addTemplatePlugins,
  Fragment: Fragment,

  getDataParser: custom_getDataParser,
  registerDataParser: registerDataParser,
  dataParser: parser_dataParser,
  colorParser: colorParser,
  unitParser: parser_unitParser,
  eventHandlerParser: parser_eventHandlerParser,

  getLocalImage: getLocalImage,
  setLocalImage: setLocalImage,

  getEventHandler: getEventHandler,
  registerEventHandler: registerEventHandler,

  Downloader: downloader,
  initIndexedDB: downloader_initIndexedDB,
  initLocalStorage: initLocalStorage,
  STORAGE_TEMPLATE: STORAGE_TEMPLATE,

  tracker: tracker["a" /* default */],
  perfTracker: perf_tracker_namespaceObject,

  Ravel: ravel,

  setGlobalConfig: config["c" /* setGlobalConfig */],
  getGlobalConfig: config["a" /* getGlobalConfig */],

  setTplCache: config["d" /* setTplCache */],
  getTplCache: config["b" /* getTplCache */],

  utils: utils
});

// 独立出口


/***/ })
/******/ ]);
});